import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import loader from "../../../assets/Images/loader.gif";
import { StyledEngineProvider } from "@mui/material/styles";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { components as RSComponents } from 'react-select'
import * as api from "../../../api_function";
// import moment from 'moment';

const optionDncNumber = [
    { value: "0", label: "Select Option" },
    { value: "111260001", label: "Yes" },
    { value: "111260000", label: "No" },
];
const optionLeadChannel = [
    { label: "Select Channel", value: "" },
    // { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
    // { label: "Caretel", value: "Caretel" },
    // { label: "CM Outbound", value: "CM Outbound" },
    // { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
    // { label: "Inside Sales", value: "Inside Sales" },
    // { label: "Inside Sales-QC", value: "Inside Sales-QC" },
    // { label: "FFA APP", value: "FFA APP" },
    // { label: "NetOps Channel", value: "NetOps Channel" },
    // { label: "Online CAF", value: "Online CAF" },
    // { label: "Outbound Call", value: "Outbound Call" },
    // { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" },
    // {
    //     label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    //     value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    // },
    // { label: "Self Care Portal", value: "Self Care Portal" },
    { label: "Self Lead", value: "Self Lead" },
    { label: "Marketing", value: "Self Lead" },

    // { label: "Unify Churned", value: "Unify Churned" },
    // { label: "Web Campaign", value: "Web Campaign" },
];
// const optionLeadChannel = ["Select Channel", "one", "two"];
// const optionLeadSource = [{ value: "", label: "Select Option" }];
const optionProductCategory = [
    { value: "", label: "Select Option" },
    { value: "AI.VIS", label: "AI.VIS" },
    { value: "BIA", label: "BIA" },
    { value: "Cloud", label: "Cloud" },
    { value: "Manage Router", label: "Manage Router" },
    { value: "Manage Wi-Fi", label: "Manage Wi-Fi" },
    { value: "Managed Firewall", label: "Managed Firewall" },
    { value: "Managed Wifi Infra", label: "Managed Wifi Infra" },
    { value: "MBB", label: "MBB" },
    { value: "MBIA", label: "MBIA" },
    { value: "SDWAN", label: "SDWAN" },
    { value: "SIP-Trunk", label: "SIP-Trunk" },
    { value: "VOIP", label: "VOIP" },
];
const optionStatusReason = [
    { value: "0", label: "Select Option" },
    { value: "111260001", label: "Closed" },
    { value: "111260000", label: "Scheduled for Appointment" },
    { value: "111260002", label: "Lead Created/Closed" },
];

const optionDisposition = [
    { value: "0", label: "Select Option" },
    { value: "569480000", label: "Busy" },
    { value: "569480001", label: "Call Back" },
    { value: "569480002", label: "Call Drop" },
    { value: "569480003", label: "Call To Sales Rep." },
    { value: "569480004", label: "Duplicate" },
    { value: "569480007", label: "Existing Customer" },
    { value: "569480008", label: "Follow Up" },
    { value: "569480009", label: "Hung Up" },
    { value: "569480010", label: "Invalid No." },
    { value: "569480011", label: "Landline Issue" },
    { value: "569480012", label: "Language Barrier" },
    { value: "569480014", label: "Lead Business" },
    { value: "569480015", label: "Lead Home" },
    { value: "569480016", label: "Location is Non RFS" },
    { value: "111260000", label: "Lost To Competition" },
    { value: "111260001", label: "No Voice" },
    { value: "111260002", label: "Not Interested" },
    { value: "111260003", label: "Not Looking For Services" },
    { value: "111260004", label: "Not Reachable" },
    { value: "111260005", label: "Nurture" },
    { value: "111260006", label: "Online Payment Done" },
    { value: "111260007", label: "Plan Expensive" },
    { value: "111260008", label: "Pre Lead Generated" },
    { value: "111260009", label: "Ringing" },
    { value: "111260010", label: "Service Related Follow up" },
    { value: "111260011", label: "Switched Off" },
    { value: "111260012", label: "Test Call" },
    { value: "111260013", label: "Using Other ISP" },
    { value: "111260014", label: "Wrong No" },
    { value: "111260015", label: "SMS Sent" },
    { value: "111260016", label: "E-Mail Sent" },
    { value: "111260017", label: "N/A" },
];
const optionCompetitorName = [
    { value: "", label: "Select Option" },
    { value: "ACT Fibernet", label: "ACT Fibernet" },
    { value: "ADTL", label: "ADTL" },
    { value: "Aircel", label: "Aircel" },
    { value: "Airtel", label: "Airtel" },
    { value: "BSNL", label: "BSNL" },
    { value: "Hathway", label: "Hathway" },
    { value: "Jio", label: "Jio" },
    { value: "MTNL", label: "MTNL" },
    { value: "N.A", label: "N.A" },
    { value: "new com", label: "new com" },
    { value: "Nextra", label: "Nextra" },
    { value: "Others", label: "Others" },
    { value: "Reliance Communications", label: "Reliance Communications" },
    { value: "Sify", label: "Sify" },
    { value: "Tata Communications", label: "Tata Communications" },
    { value: "Tata DOCOMO", label: "Tata DOCOMO" },
    { value: "Tikona Infinet", label: "Tikona Infinet" },
    { value: "Vodafone", label: "Vodafone" },
];
const pgTypeOptions = [
    { value: "111260000", label: "Men" },
    { value: "111260001", label: "Women" },
    { value: "111260002", label: "Hybrid" },
];

// Options for Tenant Type
const tenantTypeOptions = [
    { value: "111260000", label: "Professional" },
    { value: "111260001", label: "Student" },
];
const typeofproperty = [
    { value: "111260000", label: "Leased" },
    { value: "111260001", label: "Owned" },
];

const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];




const BusinessBdrContactFormPg = () => {
    const optionBarrier = [
        { label: "Select Option", value: "0" },
        { label: "Building Gate", value: "1" },
        { label: "Reception", value: "2" },
        // { label: "Cleared", value: "3" },

    ]
    const [selectBarrier, setSelectBarrier] = useState(optionBarrier[0]);

    const barrierLabel = selectBarrier?.label;
    const Selectbarr = barrierLabel === 'Select Option';
    const isGate = barrierLabel === 'Building Gate';
    const isReception = barrierLabel === 'Reception';
    const isFiltered = isGate || Selectbarr;
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };
    const [selectPGType, setSelectPGType] = useState(null);
    const [selectTenantType, setSelectTenantType] = useState(null);
    const [selectTypeofproperty, setSelectTypeofproperty] = useState(null);

    const [showForm, setShowForm] = useState(false)

    const handleSelectPGType = (selectedOption) => {
        setSelectPGType(selectedOption);
        setUserData({
            ...userData,
            pgType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Tenant Type drop-down
    const handleSelectTenantType = (selectedOption) => {
        setSelectTenantType(selectedOption);
        setUserData({
            ...userData,
            tenantType: selectedOption ? selectedOption.value : "",
        });
    };
    const handleTypeofproperty = (selectedOption) => {
        setSelectTypeofproperty(selectedOption);
        setUserData({
            ...userData,
            Typeofproperty: selectedOption ? selectedOption.value : "",
        });
    };
    // Custom styles for react-select
    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '45px',
            borderRadius: '6px',
            borderColor: '#ccc',
            backgroundColor: '#fff',  // white background
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };

    const optionQualify = [
        { label: "Not Interested", value: "569480000" },
        { label: "Delay in Response", value: "569480002" },
        { label: "Pricing issue", value: "569480003 " },
        { label: "Location Is Non-RFS", value: " 569480004" },
        { label: "Existing Customer", value: "569480007 " },
        { label: "Customer Is defaulter", value: "569480008" },
        { label: "Broadband/Home user", value: "569480010" },
        { label: "Duplicate Lead", value: "569480011" },
        { label: "Incomplete information", value: "569480012 " },
        { label: "Wrong Number", value: "569480014 " },
        { label: "Not Contactable", value: "569480015" },
        { label: "Language Barrier", value: "569480016" },
    ];

    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    //   const [otpContactStatus, setOtpContactStatus] = useState("");

        const remarkTemplate = `Connectivity Type (BB / ILL / ILL + BB / ILL + ILL): 
# BB Links (Count (Enter 0 if not used)):
Aggregate BB Bandwidth (Mbps) (Number (Enter 0 if not used)):
BB Service Provider Name(s) (Name 1, Name 2):
# ILL Links (Count (Enter 0 if not used)):
Aggregate ILL Bandwidth (Mbps) (Number (Enter 0 if not used)):
ILL Service Provider Name(s) (Name 1, Name 2):
Current Distribution Infra (Wi-Fi / LAN):
Wi-Fi Infra (AP-Own / AP-Vendor / AP-ISP, Router-Extender-Mesh):
Current Static IP Setup (Yes / No):
Static IP Count (Number of IPs if Yes above):
Current Spend (INR per month): 
Expansion/Relocation Plans (Text):
Clear Pain Felt: (Yes / No / Can't Say):
Description of Pain: (Text):
-------------------------------
`;

    const [activeForm, setActiveForm] = useState("form1");
    const [userData, setUserData] = useState({
        fullName: "",
        firstName: "",
        lastName: "",
        NameofCompany: "",
        EmployeeCount: "",
        OfficeArea: "",
        mobileOne: "",
        mobileTwo: "",
        email: "",
        campaignName: "",
        otp: "",
        specificBuilding: "",
        specificArea: "",
        remark: remarkTemplate,
        pgOwner: "",
        pgContactNum: "",
        howManyPg: "",
        pgAddress: "",
        pgAreaName: "",
        NumOfPgFloor: "",
        NumOfPgRoom: "",
        NumOfPgBed: "",
        currentWifiOperator: "",
        NumOfPgBroadband: "",
        dateOfRecharge: "",
        serviceExpect: "",
        changeReason: "",
        lease: "",
        Typeofproperty: "",
        pgName: "",
        pgType: "",             // Will be updated by handleSelectPGType
        tenantType: "",         // Will be updated by handleSelectTenantType
        spectraRFS: "",
        contactDesignation: "", // Will be updated by handleSelectContactDesignation
        numberOfRooms: "",
        numberOfBeds: "",
        perBedRent: "",
        googleRatings: "",
        pgInternetRatings: "",
        existingInternetProvider: "",
        existingInternetOutflow: "",
        currentInfra: "",
        painPoints: [], // multi-select: store as an array
        urgentTriggers: "",
        spectraRelationship: "",
        role: "",
        latitude: "",
        longitude: "",
        designation: "",
        contactPerson2Name: "",
        contactPerson2Designation: "",
        contactPerson2Mobile: "",
        contactPerson2Email: "",
        contactPerson2Role: "",
        contactPerson3Name: "",
        contactPerson3Designation: "",
        contactPerson3Mobile: "",
        contactPerson3Email: "",
        contactPerson3Role: "",
        DesignationOthers: "",
        DesignationOthers2: "",
        DesignationOthers3: "",
        specificExistingInternetProvider: "",
        existingInternetOutflowOther: "",
        NoofFloors: "",
        currentInfraOther: "",
        officeEmpCount: "",
        Officeareasqft: "",
        RoomsPerFloor: "",
        buildingNoPlotNo: "",
        block: "",
        floor: "",
        street: "",
        locality: "",
        landmarkIfAny: "",
        pinCode: "",
    });

    const optionBuildingType = [
        { label: "Single Tenant", value: "1" },
        { label: "Multi Tenant", value: "2" },
    ];

    const [selectBuildingType, setSelectBuildingType] = useState('');

    const handleSelectBuildingType = (selectBuildingType) => {
        setSelectBuildingType(selectBuildingType);
    };


    const roleOptions = [
        { value: "111260000", label: "KDM" },
        { value: "111260001", label: "Influencer" },
    ];

    const optionIndustrySegment = [
        // { value: "Others", label: "Others" },
        { value: "PG", label: "PG" },
    ];

    const [selectIndustrySegment, setSelectIndustrySegment] = useState(
        optionIndustrySegment[0]
    );




    const optionExistConnectivity = [
        { label: "Select Option", value: "0" },
        { label: "ILL", value: "1" },
        { label: "BB", value: "2" },
        { label: "New Building", value: "3" },
    ]

    const optionApplications = [
        { label: "Select Option", value: "0" },
        { label: "Cloud & Storage (AWS, Azure, etc.)", value: "1" },
        { label: "Microsoft Teams, Zoom", value: "2" },
        { label: "HRMS", value: "3" },
        { label: "CRM (Salesforce, Zoho, etc.)", value: "4" },
        { label: "ERP / SAP", value: "5" },
        { label: "Microsoft Dynamics 365", value: "6" },
    ]
    const designationOptions = [
        { value: "111260000", label: "Owner" },
        { value: "111260001", label: "Manager" },
        { value: "111260002", label: "CareTaker" },
        { value: "111260003", label: "Other" },
        // { label: "Admin Manager", value: "111260004" },
        // { label: "IT / Network Manager", value: "111260005" },
        // { label: "Other", value: "111260003" },
    ];

    // Options for Existing Internet Provider
    const existingInternetProviderOptions = [
        { value: "111260000", label: "Airtel" },
        { value: "111260001", label: "Jio" },
        { value: "111260002", label: "Tata" },
        { value: "111260003", label: "ACT" },
        { value: "111260004", label: "New Building" },
        { value: "111260005", label: "Others" },
    ];

    // Options for Existing Internet Outflow Per Month
    const existingInternetOutflowOptions = [
        { value: "111260000", label: "<5000" },
        { value: "111260001", label: "5001 - 10000" },
        { value: "111260008", label: "10001 - 20000" },
        { value: "111260009", label: ">20,000" },

        { value: "111260006", label: "New Building" },
        { value: "111260007", label: "Others" },
    ];


    // Options for Current Infra
    const currentInfraOptions = [
        { value: "111260000", label: "Broadband" },
        { value: "111260001", label: "Access Points" },
        // { value: "111260002", label: "Others" },
    ];
    // Options for Pain Points (for multi-select)
    const painPointsOptions = [
        { value: "FrequentDowntime", label: "Frequent Downtime" },
        { value: "SpeedPerformance", label: "Speed Performance" },
        { value: "HighLatency", label: "High Latency" },
        { value: "BillingDiscrepancies", label: "Billing Discrepancies" },
        { value: "PoorServiceSupportSLAViolations", label: "Poor Service Support / SLA Violations" },
        { value: "LimitedScalabilityUpgradeChallenges", label: "Limited Scalability / Upgrade Challenges" },
        { value: "SecurityConcernsComplianceIssues", label: "Security Concerns / Compliance Issues" },
        { value: "BadCoverageInfrastructureLimitations", label: "Bad Coverage / Infrastructure Limitations" },
        { value: "NoRedundancybackuplink", label: "No Redundancy / Backup Link" },
        { value: "NoMonitoringUsageReport", label: "No Monitoring / Usage Report" },
    ];


    const [selectedReasons, setSelectedReasons] = useState([])
    const handleSendOtp = async (email, mobileNo) => {
        // console.log("Button clicked");
        if (!userData.contactPerson3Name) {
            toast.warning("Please Enter Person Met Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!selectContact3Designation) {
            toast.warning("Please Select Person Met Designation", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!userData.contactPerson3Mobile) {
            toast.warning("Please Enter Person Met Contact Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }

        else if (userData.contactPerson3Mobile.length < 10) {
            toast.warning("Please Enter Enter Person Met Contact Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        // else if (!userData.contactPerson3Email) {
        //     toast.warning("Please Enter the Person Met Email ID", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        //  else if (
        //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
        // ) {
        //     toast.warning("Please Enter Customer Email Id", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // } 
        else {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const otpRequestBody = {
                    Action: "sendOTPContact",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    mobileNo: mobileNo,
                    preOTP: "",
                    userEmail: email,
                };
                const otpResponse = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(otpRequestBody),
                });
                const sendOtpData = await otpResponse.json();
                // console.log("send otp :",sendOtpData)
                if (sendOtpData.Status === "Success") {
                    // console.log("send otp :",sendOtpData.Status)
                    toast.success("Happy Code Sent", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    // Make fields uneditable for 30 seconds
                    setFieldsEditable(false);
                    // setTimeout(() => {
                    //     setFieldsEditable(true);
                    // }, 30000); // 30 seconds

                    setOtpSent(true);
                    setOtp(sendOtpData.Response);
                    setIsLoading(false);
                    // console.log("sendOtpData.Response :", sendOtpData.Response);
                } else {
                    // console.error('Failed to send OTP:', otpResponse.statusText);
                    toast.warning(otpResponse.statusText, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error sending OTP:", error);
            }
        }
    };
    const clickSubmit = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to Submit the record ? Once Submitted , Contact will not be editable.</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">SUBMIT</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubmit();
            } else {
                navigate("/businessBdrContactFormPg");
            }
        });
    };
    const handleVerifyOtp = () => {
        const otpValue = String(otp).trim();
        const customerOtpValue = userData.otp.trim();
        // console.log("customerData.otp :",customerData.otp);
        // console.log("otp :",otp);
        setIsLoading(true);
        if (otpValue === customerOtpValue) {
            toast.success("Happy Code verified Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            setOtpContactStatus("111260000");
            setIsLoading(false);
        } else {
            toast.warning("Incorrect Happy Code", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            setOtpContactStatus("111260001");
            setIsLoading(false);
        }
    };

    const handleResendOtp = async (email, mobileNo) => {
        const otpValue = String(otp).trim();
        if (!userData.contactPerson3Name) {
            toast.warning("Please Enter Person Met Name", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!selectContact3Designation) {
            toast.warning("Please Select Person Met Designation", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (!userData.contactPerson3Mobile) {
            toast.warning("Please Enter Person Met Contact Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        else if (userData.contactPerson3Mobile.length < 10) {
            toast.warning("Please Enter Person Met Contact Number", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
        // else if (!userData.contactPerson3Email) {
        //     toast.warning("Please Enter the Person Met Email ID", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // }
        //  else if (
        //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)
        // ) {
        //     toast.warning("Please Enter Customer Email Id", {
        //         position: toast.POSITION.BOTTOM_CENTER,
        //         autoClose: 1500,
        //     });
        // } 
        else {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const otpRequestBody = {
                    Action: "sendOTPContact",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    mobileNo: mobileNo,
                    preOTP: otpValue,
                    userEmail: email,
                };
                const otpResponse = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(otpRequestBody),
                });
                const resendOtpData = await otpResponse.json();
                // console.log("resend otp :", resendOtpData);
                if (resendOtpData.Status === "Success") {
                    // console.log("send otp :",resendOtpData.Status)
                    toast.success("Happy Code Sent ", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setIsLoading(false);
                    setFieldsEditable(false);
                    // setTimeout(() => {
                    //     setFieldsEditable(true);
                    // }, 30000); // 30 seconds
                    // setOtpSent(true);
                    // setOtp(resendOtpData.Response);
                    // console.log("sendOtpData.Response :",sendOtpData.Response)
                } else {
                    toast.warning(otpResponse.statusText || "Failed to send OTP", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Error sending OTP:", error);
            }
        }
    };
    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }

    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )



    const handleDisqualify = async () => {
        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.')
            return
        }

        const reasonList = selectedReasons.map(o => o.label).join(', ')
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'contactDisqualify',           // ← your new API action
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            ContactID: ContactId,                   // fixed key name
            ReasonForDisqualify: reasonList
        }

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            const data = await res.json()

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Contact disqualified successfully!', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                })
                navigate('/businessContactProWifi')
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to disqualify')
            }
        } catch (err) {
            console.error(err)
            toast.error('Network error, please try again.')
        }
    };



    const apiUrl = process.env.REACT_APP_API_URL;
    const [barrierstatus, setbarrierstatus] = useState("");
    const [currentWorkLocations, setCurrentWorkLocations] = useState("");
    const [employeeCountOptions, setEmployeeCountOptions] = useState([]);
    const [selectedEmployeeCount, setSelectedEmployeeCount] = useState(null);

    const [officeAreaOptions, setOfficeAreaOptions] = useState([]);
    const [selectedOfficeArea, setSelectedOfficeArea] = useState(null);

    const [industryTypes, setIndustryTypes] = useState([]);

    const [selectIndustryType, setSelectIndustryType] = useState("");

    const [accessPointOptions, setAccessPointOptions] = useState([]);
    const [selectedAccessPoint, setSelectedAccessPoint] = useState(null);
    const handleSelectIndustryType = (selectIndustryType) => {
        setSelectIndustryType(selectIndustryType);
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Industry API call
                const industryTypeApiUrl = process.env.REACT_APP_API_URL;
                const industryTypeRequestBody = {
                    Action: "getindustrytype",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    areaCode: "",
                    areaName: "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const industryTypeResponse = await fetch(industryTypeApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(industryTypeRequestBody),
                });
                const industryTypeData = await industryTypeResponse.json();
                // setIndustryTypes(industryTypeData.Response);
                // console.log("industryTypeData :",industryTypeData.Response)
                if (industryTypeData.Response) {
                    const transformedOptions = industryTypeData.Response.map(
                        (option) => ({
                            label: option.IndTypeName,
                            value: option.IndTypeId,
                        })
                    );
                    setIndustryTypes(transformedOptions);
                    // console.log("transformedOptions",transformedOptions)
                } else {
                    setIndustryTypes([]);
                }

                const CityApiUrl = process.env.REACT_APP_API_URL;
                const CityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: "0",
                    userName: sessionStorage.getItem('userName'),
                };
                const CityResponse = await fetch(CityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(CityRequestBody),
                });
                const CityData = await CityResponse.json();

                if (CityData.Response.Data) {
                    const transformedOptions = CityData.Response.Data.map(
                        (option) => ({
                            label: option.CityName,
                            value: option.CityCode,
                        })
                    );
                    setCurrentWorkLocations(transformedOptions);
                } else {
                    setCurrentWorkLocations([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);



    const [selectContactDesignation, setSelectContactDesignation] = useState(null);
    const handleEmailBlur = (e) => {
        const email = e.target.value;
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

        if (email && !emailRegex.test(email)) {
            toast.error("Invalid email address", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 3000,
            });
        }
    };


    // Handler for Contact Designation drop-down
    const handleSelectContactDesignation = (selectedOption) => {
        setSelectContactDesignation(selectedOption);
        setUserData({
            ...userData,
            contactDesignation: selectedOption ? selectedOption.value : "",
        });
    };
    const [isLoading, setIsLoading] = useState(false);
    const [selectDNCno, setSelectDNCno] = useState(optionDncNumber[0]);
    const [selectLeadChannel, setSelectLeadChannel] = useState(
        optionLeadChannel[0]
    );
    const [selectLeadSource, setSelectLeadSource] = useState();
    const [leadSourceOptions, setLeadSourceOptions] = useState([]);
    const [selectProductCategory, setSelectProductCategory] = useState(
        optionProductCategory[0]
    );
    const [selectStatusReason, setSelectStatusReason] = useState(
        optionStatusReason[0]
    );
    const [checkStatusReason, setCheckStatusReason] = useState("");
    const [selectDisposition, setSelectDisposition] = useState(
        optionDisposition[0]
    );
    const [selectCompetitorName, setSelectCompetitorName] = useState(
        optionCompetitorName[0]
    );


    const [officeEmpCount, setOfficeEmpCount] = useState("");
    const [optionOfficeEmpCount, setOptionOfficeEmpCount] = useState([]);
    const [coverageAreaRange, setCoverageAreaRange] = useState("");
    const [optionCoverageAreaRange, setOptionCoverageAreaRange] = useState([]);

    const [selectOfficeArea, setSelectOfficeArea] = useState("");
    const [selectExistConnectivity, setSelectExistConnectivity] = useState(optionExistConnectivity[0]);
    const [selectApplications, setSelectApplications] = useState(optionApplications[0]);
    const [selectProductName, setSelectProductName] = useState([0]);
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [selectState, setSelectState] = useState("");
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");



    const [fieldsEditable, setFieldsEditable] = useState(true);
    const [otpContactStatus, setOtpContactStatus] = useState("");
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    // const [cityCode , setCityCode]=useState("");
    // const [cityName , setCityName]=useState("");
    // For Contact Person 2 dropdowns
    const [selectContact2Designation, setSelectContact2Designation] = useState(null);
    const [selectContact2Role, setSelectContact2Role] = useState(null);

    // For Contact Person 3 dropdowns
    const [selectContact3Designation, setSelectContact3Designation] = useState(null);
    const [selectContact3Role, setSelectContact3Role] = useState(null);
    const [meetingcounter, setmeetingcounter] = useState("");

    // Generic change handler for text/number inputs


    const handleSelectCoverageAreaRange = (selected) => {
        setCoverageAreaRange(selected);
    };

    const handleSelectOfficeEmpCount = (selected) => {
        setOfficeEmpCount(selected);
        setCoverageAreaRange("")
    };

    const handleSelectBarrier = (selected) => {
        setSelectBarrier(selected);
    };




    const handleSelectApplications = (selected) => {
        setSelectApplications(selected);
    };


    // Handler for Contact Person 2 Designation dropdown
    const handleSelectContact2Designation = (selectedOption) => {
        setSelectContact2Designation(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson2Designation: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 2 Role dropdown
    const handleSelectContact2Role = (selectedOption) => {
        setSelectContact2Role(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson2Role: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 3 Designation dropdown
    const handleSelectContact3Designation = (selectedOption) => {
        setSelectContact3Designation(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson3Designation: selectedOption ? selectedOption.value : "",
        }));
    };

    // Handler for Contact Person 3 Role dropdown
    const handleSelectContact3Role = (selectedOption) => {
        setSelectContact3Role(selectedOption);
        setUserData((prevData) => ({
            ...prevData,
            contactPerson3Role: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleChange = (e) => {

        // console.log(e.target.name);
        // console.log(e.target.value);
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (e) => {

        // console.log(e.target.name);
        // console.log(e.target.value);
        setUserData({ ...userData, [e.target.name]: isNaN(parseInt(e.target.value, 10)) ? "" : parseInt(e.target.value, 10) });
    };





    const handleSelectLead = (selectLead) => {
        setSelectLeadChannel(selectLead);
    };
    const handleSelectLeadSource = (selectLeadSource) => {
        setSelectLeadSource(selectLeadSource);
    };
    const handleSelectProductCategory = (selectProductCategory) => {
        setSelectProductCategory(selectProductCategory);
    };
    const handleSelectStatusReason = (selectStatusReason) => {
        setSelectStatusReason(selectStatusReason);
    };


    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setUserData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setUserData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };



    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);
    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setUserData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };
    // Current Infra (using placeholder options; update as needed)

    const [selectCurrentInfra, setSelectCurrentInfra] = useState(null);
    const handleSelectCurrentInfra = (selectedOption) => {
        setSelectCurrentInfra(selectedOption);
        setUserData((prev) => ({
            ...prev,
            currentInfra: selectedOption ? selectedOption.value : "",
        }));
    };


    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setUserData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
        getLocation();

    };

    const handleSelectIndustrySegment = (selectIndustrySegment) => {
        setSelectIndustrySegment(selectIndustrySegment);
        getLocation();

    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL_3;
                const RequestBody = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getBBDIAEmpCount",
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.office_employee_count,
                            value: option.office_employee_count_id,
                        })
                    );
                    setOptionOfficeEmpCount(options);

                } else {
                    setOptionOfficeEmpCount([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        if (!officeEmpCount?.value) return;
        const fetchCoverageAreaRange = async () => {
            try {
                const url = process.env.REACT_APP_API_URL_3;
                const RequestBody = {
                    "Action": "getBBDIAOffArea",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "empCount": officeEmpCount.value
                }
                const Response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(RequestBody),
                });
                const data = await Response.json();
                // console.log("data", data);

                if (data.Response) {
                    const options = data.Response.map(
                        (option) => ({
                            label: option.coverage_area_range,
                            value: option.coverage_area_range_id,
                        })
                    );
                    setOptionCoverageAreaRange(options);
                } else {
                    setOptionCoverageAreaRange([])
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchCoverageAreaRange();
    }, [officeEmpCount]);




    const handleQualify = async () => {
        // Email validation
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userData.email)) {
            toast.warning('Please Enter Email Address', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }


        if (!selectExistingInternetProvider) {
            toast.error('Existing Internet Provider must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (selectExistingInternetProvider?.value == "111260005" && !userData.specificExistingInternetProvider) {
            toast.error('Specific Internet Provider must be entered', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (!selectExistingInternetOutflow) {
            toast.error('Existing Internet Outflow must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (selectExistingInternetOutflow?.value == "111260007" && !userData.existingInternetOutflowOther) {
            toast.error('Specific Existing Internet Outflow must be entered', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (!selectPainPoints || selectPainPoints?.length === 0) {
            toast.error('Please select at least one Pain Point', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });

        }
        else if (!officeEmpCount?.value) {
            toast.error('Employee Count must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else if (!coverageAreaRange?.value) {
            toast.error('Total Office Area must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });

        }
        else if (selectApplications?.value == "0") {
            toast.error('Applications must be selected', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        }
        else {
            // Perform qualify API
            // alert("done")
            try {
                const qualifyData = {
                    Action: 'contactQualifyDisqualify',
                    Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
                    CantactID: ContactId,
                    CantactStatus: 'Yes',
                    password: sessionStorage.getItem('password'),
                    ReasonForDisqualify: '',
                    userName: sessionStorage.getItem('userName')
                };
                const res = await fetch(apiUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(qualifyData)
                });
                const data = await res.json();
                if (data.Response.StatusCode === 200) {
                    toast.success('Contact Qualified Successfully', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
                    navigate('/businessLeadProWifi');
                } else {
                    toast.warning(data.Response.Message, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
                }
            } catch (err) {
                console.error(err);
            }
        }

    };





    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        setSelectArea("");
        setSelectBuilding("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem("password"),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem("userName"),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectState = (selectedState) => {
        setSelectState(selectedState);
        setSelectCity("");
        setSelectArea("");
        setSelectBuilding("");
    };

    const [position, setPosition] = useState({ latitude: null, longitude: null });

    // const getLocation = () => {
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             setPosition({
    //                 latitude: position.coords.latitude,
    //                 longitude: position.coords.longitude,
    //                 message: "Location Captured",
    //             });
    //         });
    //     } else {
    //         // console.log("Geolocation is not available in your browser.");
    //         toast.warning("location is not available in your browser.", {
    //             position: toast.POSITION.BOTTOM_CENTER,
    //             autoClose: 1500,
    //         });
    //     }
    //     console.log("area :", position)
    // };

    const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check browser permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported by this browser.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

    // Log updated location when it changes
    useEffect(() => {
        if (position.latitude && position.longitude) {
            console.log("Updated position:", position);
        }
    }, [position]);


    useEffect(() => {
        getLocation();
    }, []);

    useEffect(() => {

        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem("password"),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem("userName"),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    setCityType(cityData.Response.Data);
                } else {
                    // console.error("City data structure not recognized:",cityData.Response);
                    // setCityType([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        // fetchCities();
        // Fetch cities only if a state is selected
        if (selectState) {
            fetchCities();
        }
    }, [selectState]);


    const handleSelectArea = async (selectedOption) => {
        setSelectArea(selectedOption);
        const areaCode = selectedOption.value;
        const areaName = selectedOption.label.split(" ")[0];
        setSelectBuilding("");
        try {
            const buildingApiUrl = process.env.REACT_APP_API_URL;
            const buildingRequestBody = {
                Action: "getBuilding",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                areaCode: areaCode,
                areaName: areaName,
                password: sessionStorage.getItem("password"),
                userName: sessionStorage.getItem("userName"),
            };

            const buildingResponse = await fetch(buildingApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(buildingRequestBody),
            });
            const buildingData = await buildingResponse.json();
            if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
                setBuildingList(buildingData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };






    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const ContactId = searchParams.get("ContactId");
    // console.log("ContactId :", ContactId);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // lead source API call
                const leadSourceApiUrl = process.env.REACT_APP_API_URL;
                const leadSourceRequestBody = {
                    Action: "getSource",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    channelName: selectLeadChannel.value,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const leadSourceResponse = await fetch(leadSourceApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(leadSourceRequestBody),
                });
                const leadSourceData = await leadSourceResponse.json();
                // console.log("lead Source :", leadSourceData.Response.Data);
                // Check if data is not undefined or null before mapping
                if (leadSourceData.Response.Data) {
                    // Transforming data into the required format
                    const transformedOptions = leadSourceData.Response.Data.map(
                        (option) => ({
                            label: option.SourceName,
                            value: option.SourceName,
                        })
                    );
                    // console.log("setLeadSourceOptions",transformedOptions)
                    setLeadSourceOptions(transformedOptions);
                    if (!ContactId && transformedOptions.length > 0) {
                        setSelectLeadSource(transformedOptions[0]);
                    }
                } else {
                    // If data is undefined or null, set leadSourceOptions to an empty array
                    setLeadSourceOptions([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [selectLeadChannel, ContactId]);

    // Get the current date and time
    const currentDate = new Date();
    // Extract individual components
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Note: Months are zero-based (0-January, 1-February, etc.)
    const date = currentDate.getDate();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();
    // Format the date and time as a string
    const formattedDateTime = `${year}-${month < 10 ? "0" + month : month}-${date < 10 ? "0" + date : date
        } ${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes
        }:${seconds < 10 ? "0" + seconds : seconds}`;
    // console.log("Current Date and Time:", formattedDateTime);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getContactPGOffice",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    contactID: ContactId,

                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // const data = await response.json();
                const apiData = data.Response.Data[0];

                // console.log("getContact", data);
                // console.log("FollowupDate :", data.Response.Data[0].NumberofRooms)
                // console.log("data.Response.Data[0].ExistingInternetProviderOther", data.Response.Data[0].ExistingInternetProviderOther);
                setUserData({
                    fullName: data.Response.Data[0].FullName,
                    firstName: data.Response.Data[0].FirstName,
                    lastName: data.Response.Data[0].LastName,
                    mobileOne: data.Response.Data[0].MobileNumber,
                    mobileTwo: data.Response.Data[0].MobileNumber2,
                    email: data.Response.Data[0].EmailAddress,
                    campaignName: data.Response.Data[0].CampaignName,
                    specificBuilding: data.Response.Data[0].Specifybuilding,
                    specificArea: data.Response.Data[0].SpecifyArea,
                    remark: data.Response.Data[0].Remark,
                    pgName: data.Response.Data[0].PGName,
                    spectraRFS: data.Response.Data[0].SpectraRFS,
                    DesignationOthers: data.Response.Data[0].DesignationOthers,
                    numberOfRooms: data.Response.Data[0].NumberofRooms,
                    numberOfBeds: data.Response.Data[0].NumberofBeds,
                    perBedRent: data.Response.Data[0].PerBedRent,

                    NoofFloors: data.Response.Data[0].NoofFloors,
                    RoomsPerFloor: data.Response.Data[0].RoomsPerFloor,
                    officeEmpCount: data.Response.Data[0].Officeemployeecount,
                    Officeareasqft: data.Response.Data[0].Officeareasqft,
                    lease: data.Response.Data[0].DurationofLease,

                    currentInfraOther: data.Response.Data[0].CurrentInfraOther,
                    googleRatings: data.Response.Data[0].GoogleRatings,
                    pgInternetRatings: data.Response.Data[0].PGInternetRatings,
                    contactPerson2Name: apiData.ContactPerson2,
                    contactPerson2Email: apiData.EmailID2,
                    contactPerson2Mobile: apiData.MobileNumber2, // Make sure your API field is correct
                    DesignationOthers2: data.Response.Data[0].DesignationOthers2, // Extra info if needed
                    contactPerson2Designation: apiData.Designation2, // For dropdown
                    contactPerson2Role: apiData.Role2,              // For dropdown
                    // Contact Person 3 details
                    contactPerson3Name: apiData.Personmetname,
                    contactPerson3Email: apiData.PersonmetEmailID,
                    contactPerson3Mobile: apiData.Personmetmobilenumber,
                    DesignationOthers3: data.Response.Data[0].DesignationOthers3, // Extra info if needed
                    contactPerson3Designation: apiData.Personmetdesignation,
                    contactPerson3Role: apiData.Role3,
                    pgType: apiData.PGType,
                    tenantType: apiData.TenantType,
                    lease: apiData.DurationofLease,
                    Typeofproperty: apiData.Typeofproperty,
                    existingInternetProvider: apiData.ExistingInternetProvider,
                    existingInternetOutflow: apiData.ExistingInternetOutflowPerMonth,
                    currentInfra: apiData.CurrentInfra,
                    urgentTriggers: apiData.UrgentTriggers,
                    spectraRelationship: apiData.SpectraRelationship,
                    role: apiData.Role,
                    designation: apiData.Designation,
                    contactDesignation: apiData.Designation,
                    latitude: apiData.Latitude,
                    longitude: apiData.Longitude,
                    NameofCompany: apiData.CompanyName || '',
                    EmployeeCount: apiData.EmployeeCount || '',
                    OfficeArea: apiData.OfficeArea || '',
                    specificExistingInternetProvider: data.Response.Data[0].ExistingInternetProviderOther,
                    existingInternetOutflowOther: data.Response.Data[0].ExistingInternetOutflowPerMonthOther,
                    buildingNoPlotNo: apiData.BuildingNoPlotNo,
                    block: apiData.Block,
                    floor: apiData.Floor,
                    street: apiData.Street,
                    locality: apiData.Locality,
                    landmarkIfAny: apiData.LandmarkIfAny,
                    pinCode: apiData.PinCode,


                    // For pain points, create an array based on boolean "1" values
                    painPoints: [
                        // apiData.PoorCustomerReviews === "1" && "poorCustomerReviews",
                        // apiData.TenantComplaints === "1" && "tenantComplaints",
                        // apiData.TenantChurn === "1" && "tenantChurn",
                        // apiData.PoorCustomerSupportfromexistingvendor === "1" && "poorCustomerSupport",
                        // apiData.MultipleVendors === "1" && "multipleVendors",
                        // apiData.NewBuilding === "1" && "newBuilding",

                        apiData.FrequentDowntime === "1" && "FrequentDowntime",
                        apiData.SpeedPerformance === "1" && "SpeedPerformance",
                        apiData.HighLatency === "1" && "HighLatency",
                        apiData.BillingDiscrepancies === "1" && "BillingDiscrepancies",
                        apiData.PoorServiceSupportSLAViolations === "1" && "PoorServiceSupportSLAViolations",
                        apiData.LimitedScalabilityUpgradeChallenges === "1" && "LimitedScalabilityUpgradeChallenges",
                        apiData.SecurityConcernsComplianceIssues === "1" && "SecurityConcernsComplianceIssues",
                        apiData.BadCoverageInfrastructureLimitations === "1" && "BadCoverageInfrastructureLimitations",
                        apiData.NoRedundancybackuplink === "1" && "NoRedundancybackuplink",
                        apiData.NoMonitoringUsageReport === "1" && "NoMonitoringUsageReport",
                    ].filter(Boolean),
                });
                setOtpContactStatus(apiData.StatusReason)
                setSelectBuildingType(optionBuildingType.find(option => option.value === apiData.BuildingType))
                setbarrierstatus(apiData.Barriers)
                setmeetingcounter(apiData.MeetingCounter);
                setSelectContact2Designation(
                    designationOptions.find(option => option.value === apiData.Designation2)
                );
                setSelectContact2Role(
                    roleOptions.find(option => option.value === apiData.Role2)
                );

                // *** Populate Contact Person 3 Dropdowns ***
                setSelectContact3Designation(
                    designationOptions.find(option => option.value === apiData.Personmetdesignation)
                );
                setSelectContact3Role(
                    roleOptions.find(option => option.value === apiData.Role3)
                );

                // const roleData = data.Response.Data[0].Role;
                // const designationData = data.Response.Data[0].Designation;
                setSelectPGType(
                    pgTypeOptions.find(option => option.value === data.Response.Data[0].PGType)
                );

                // Tenant Type
                setSelectTenantType(
                    tenantTypeOptions.find(option => option.value === data.Response.Data[0].TenantType)
                );
                setSelectTypeofproperty(
                    typeofproperty.find(option => option.value === data.Response.Data[0].Typeofproperty)
                );

                const filterBarrierId = optionBarrier?.find(item => item.value == String(data.Response.Data[0]?.Barriers))?.label;
                if (filterBarrierId) {
                    setSelectBarrier({
                        value: data.Response.Data[0].Barriers,
                        label: filterBarrierId,
                    });
                }

                setSelectCurrentInfra(
                    currentInfraOptions.find(option => option.value === data.Response.Data[0].CurrentInfra)
                );


                const empCount = await api.getBBDIAEmpCount();

                const empCountOptionSet = empCount?.Response?.map(item => ({
                    value: item.office_employee_count_id,
                    label: item.office_employee_count
                }));

                setOfficeEmpCount(empCountOptionSet.find(item => item.value == data.Response?.Data[0]?.EmployeeCount) || null)

                const officeArea = await api.getBBDIAOffArea(data.Response?.Data[0].OfficeArea);

                const officeAreaOptionSet = officeArea?.Response?.map(item => ({
                    value: item.coverage_area_range_id,
                    label: item.coverage_area_range
                }));

                // console.log("getOpp officeAreaOptionSet: ", officeAreaOptionSet, pgInfo.OfficeArea);
                setCoverageAreaRange(officeAreaOptionSet.find(item => item.value == data.Response?.Data[0]?.OfficeArea) || null)


                // console.log("optionExistConnectivity", data.Response[0]?.PgInfo.ExistingConnectivity);

                const filterExistCon = optionExistConnectivity?.find(item => item.value == String(data.Response.Data[0].ExistingConnectivity))?.label;
                if (filterExistCon) {
                    setSelectExistConnectivity({
                        value: data.Response.Data[0].ExistingConnectivity,
                        label: filterExistCon,
                    });
                }
                const filterApplications = optionApplications?.find(item => item.value == String(data.Response.Data[0].Applications))?.label;
                if (filterApplications) {
                    setSelectApplications({
                        value: data.Response.Data[0].Applications,
                        label: filterApplications,
                    });
                }



                // Existing Internet Provider
                setSelectExistingInternetProvider(
                    existingInternetProviderOptions.find(
                        option => option.value === data.Response.Data[0].ExistingInternetProvider
                    )
                );

                // Existing Internet Outflow Per Month
                setSelectExistingInternetOutflow(
                    existingInternetOutflowOptions.find(
                        option => option.value === data.Response.Data[0].ExistingInternetOutflowPerMonth
                    )
                );



                // Extract the pain points data from the response
                const painPointsResponse = data.Response.Data[0];

                // Build an array of selected pain point values based on the API response
                const selectedPainPoints = [];

                if (painPointsResponse.FrequentDowntime === "1") {
                    selectedPainPoints.push("FrequentDowntime");
                }
                if (painPointsResponse.SpeedPerformance === "1") {
                    selectedPainPoints.push("SpeedPerformance");
                }
                if (painPointsResponse.HighLatency === "1") {
                    selectedPainPoints.push("HighLatency");
                }
                if (painPointsResponse.BillingDiscrepancies === "1") {
                    selectedPainPoints.push("BillingDiscrepancies");
                }
                if (painPointsResponse.PoorServiceSupportSLAViolations === "1") {
                    selectedPainPoints.push("PoorServiceSupportSLAViolations");
                }
                if (painPointsResponse.LimitedScalabilityUpgradeChallenges === "1") {
                    selectedPainPoints.push("LimitedScalabilityUpgradeChallenges");
                }

                if (painPointsResponse.SecurityConcernsComplianceIssues === "1") {
                    selectedPainPoints.push("SecurityConcernsComplianceIssues");
                }
                if (painPointsResponse.BadCoverageInfrastructureLimitations === "1") {
                    selectedPainPoints.push("BadCoverageInfrastructureLimitations");
                }
                if (painPointsResponse.NoRedundancybackuplink === "1") {
                    selectedPainPoints.push("NoRedundancybackuplink");
                }
                if (painPointsResponse.NoMonitoringUsageReport === "1") {
                    selectedPainPoints.push("NoMonitoringUsageReport");
                }
                // setSelectPainPoints(selectedPainPoints);

                // Update the state with the full option objects that match the selected values
                setSelectPainPoints(
                    painPointsOptions.filter(option => selectedPainPoints.includes(option.value))
                );





                setSelectRole(roleOptions.find(option => option.value === apiData.Role));
                setSelectContactDesignation(designationOptions.find(option => option.value === apiData.Designation));




                setSelectDNCno({
                    value: data.Response.Data[0].DncNumber,
                    label: data.Response.Data[0].DncNumber,
                });
                setSelectLeadChannel({
                    value: data.Response.Data[0].Channel,
                    label: data.Response.Data[0].Channel,
                });
                setSelectLeadSource({
                    value: data.Response.Data[0].Source,
                    label: data.Response.Data[0].Source,
                });
                setSelectProductCategory({
                    value: data.Response.Data[0].PlanCategory,
                    label: data.Response.Data[0].PlanCategory,
                });
                setSelectStatusReason({
                    value: data.Response.Data[0].StatusReason,
                    label: data.Response.Data[0].StatusReason,
                });
                setCheckStatusReason(data.Response.Data[0].StatusReason);
                setSelectDisposition({
                    value: data.Response.Data[0].Disposition,
                    label: data.Response.Data[0].Disposition,
                });
                setSelectCompetitorName({
                    value: data.Response.Data[0].CompetitorName,
                    label: data.Response.Data[0].CompetitorName,
                });


                // const filterIndustryType = industryTypes.find(item => item.value === String(data.Response.Data[0].IndustryTypeId)).label;
                setSelectIndustrySegment(
                    {
                        value: data.Response.Data[0].IndustryTypeId,
                        label: data.Response.Data[0].IndustryTypeId,
                    });
                let getdate = data.Response.Data[0].FollowupDate;
                let changeFormatDate = dayjs(getdate, "DD-MM-YYYY HH:mm:ss")
                // console.log("changeFormatDate",changeFormatDate);
                setSelectedDateTime(changeFormatDate);

                const filterState = optionState.find(
                    (item) => item.name === data.Response.Data[0].State
                )?.code;
                // console.log("filterState",filterState)
                setSelectState({
                    value: filterState,
                    label: data.Response.Data[0].State,
                });
                setSelectCity({
                    value: data.Response.Data[0].CityId,
                    label: data.Response.Data[0].City,
                });
                setSelectArea({
                    value: data.Response.Data[0].AreaId,
                    label: `${data.Response.Data[0].Area} `,
                });
                setSelectBuilding({
                    value: data.Response.Data[0].BuildingId,
                    label: `${data.Response.Data[0].Building}`,
                });
            } catch (error) {
                //console.error("Error fetching data:", error);
                toast.warning(error, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 500,
                });
                setIsLoading(false);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [ContactId]);
    // console.log("FollowupDate12345 :", userData.numberOfRooms)

    const handleSubmit = async () => {
        const barrierValue = selectBarrier?.label;

        // Mandatory: CompanyName + Barrier
        if (!userData.pgName) {
            toast.warning("Please Enter Name of PG", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }
        if (!barrierValue) {
            toast.warning("Barrier must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }




        // Building Gate -> only CompanyName + Barrier
        // if (barrierValue === "Building Gate") {
        //     await processSubmission();
        //     return;
        // }

        // Office Reception -> + State, City, Area, Building
        if (barrierValue === "Building Gate") {
            if (!selectState) { toast.warning("Please Select State", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (!selectCity) { toast.warning("Please Select City", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (!selectArea.value) { toast.warning("Please Select Area", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (selectArea.value == "10226" && !userData.specificArea) { toast.warning("Please Enter Specific Area", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (!selectBuilding.value) { toast.warning("Please Select Building", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (selectBuilding.value == "13334" && !userData.specificBuilding) { toast.warning("Please Enter Specific Building", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
            if (!userData?.buildingNoPlotNo) { toast.warning("Building No must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            if (!selectBuildingType?.value) { toast.warning("Building Type must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            if (!userData?.block) { toast.warning("Block must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            if (!userData?.floor) { toast.warning("floor must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            if (!userData?.street) { toast.warning("Street must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            if (!userData?.pinCode) { toast.warning("Pin Code must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }); return; }
            await processSubmission();
            return;
        }

        // Barrier cleared or others -> full validations
        if (!selectPGType) {
            toast.warning("PG Type must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (!selectTenantType) {
            toast.warning("Tenant Type must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (!userData.firstName) {
            toast.warning("Please Enter First Name", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.lastName) {
            toast.warning("Please Enter Last Name", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.mobileOne || userData.mobileOne.length < 10) {
            toast.warning("Please Enter Mobile Number", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!selectRole) {
            toast.warning("Role must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }
        if (!selectContactDesignation) {
            toast.warning("Contact Designation must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }
        if (selectContactDesignation?.label == "Other" && !userData.DesignationOthers) {
            toast.warning("Contact Specific Designation must be entered", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }
        if (!userData.numberOfRooms) {
            toast.warning("Please Enter number of Rooms", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.numberOfBeds) {
            toast.warning("Please Enter number of Beds", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.perBedRent) {
            toast.warning("Enter Per Bed Rent", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.NoofFloors) {
            toast.warning("Please Enter Number of Floors", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!userData.RoomsPerFloor) {
            toast.warning("Please Enter Rooms Per floor", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        // if (!selectIndustrySegment?.value) {
        //     toast.warning("Industry Segment must be selected", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        //     return;
        // }
        if (!selectState) {
            toast.warning("Please Select State", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!selectCity) {
            toast.warning("Please Select City", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (!selectArea.value) {
            toast.warning("Please Select Area", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (selectArea.value == "10226" && !userData.specificArea) { toast.warning("Please Enter Specific Area", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
        if (!selectBuilding.value) {
            toast.warning("Please Select Building", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 });
            return;
        }
        if (selectBuilding.value == "13334" && !userData.specificBuilding) { toast.warning("Please Enter Specific Building", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 500 }); return; }
        if (!userData?.remark) {
            toast.warning("Please enter the remarks", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            return;
        }
        await processSubmission();

    };

    const processSubmission = async () => {
         let finalRemark = userData.remark || "";
        if (userData.remark?.trim()) {
            const userName = sessionStorage.getItem("userName") || "Unknown User";
            const now = new Date();
            const timestamp = now.toLocaleString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });

            const formattedRemark = `${userName}[${timestamp}]: \n${userData.remark}\n`;
            finalRemark = formattedRemark;
        }
        setIsLoading(true);
        const isUpdate = Boolean(ContactId);
        const payload = {
            Action: isUpdate ? "updateContactPGOffice" : "createContactPGOffice",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            area: selectArea?.value ? selectArea.value : "",
            building: selectBuilding?.value ? selectBuilding.value : "",
            BusinessSegment: "Business",
            callAttempted: "1",
            campaignName: userData.campaignName ? userData.campaignName : "",
            channel: selectLeadChannel?.value ? selectLeadChannel.value : "",
            city: selectCity?.value ? selectCity.value : "",
            competitorName: selectCompetitorName?.value ? selectCompetitorName.value : "",
            ContactId: ContactId ? ContactId : "",
            // ContactVerificationStatus: otpContactStatus ? otpContactStatus : "",
            ContactVerificationStatus:
                otpContactStatus && otpContactStatus !== "Open" && otpContactStatus !== "Contact - Complete" && otpContactStatus !== "Contact - Incomplete" && otpContactStatus !== "Contact - Valid"
                    ? otpContactStatus
                    : "",

            CompanyName: userData.NameofCompany ? userData.NameofCompany : "",
            disposition: selectDisposition?.value ? selectDisposition.value : "",
            dncNumber: selectDNCno?.value ? selectDNCno.value : "",
            emailAddress: userData.email ? userData.email : "",
            firstName: userData.firstName ? userData.firstName : "",
            followupDate: selectedDateTime ? selectedDateTime : "",
            lastName: userData.lastName ? userData.lastName : "",
            mobileNumber: userData.mobileOne ? userData.mobileOne : "",
            mobileNumber2: userData.contactPerson2Mobile ? userData.contactPerson2Mobile : "",
            password: sessionStorage.getItem("password") ? sessionStorage.getItem("password") : "",
            planCategory: selectProductCategory?.value ? selectProductCategory.value : "",
            industryTypeId: "IND_0068_ID",
            ContactPerson2: userData.contactPerson2Name ? userData.contactPerson2Name : "",
            EmailID2: userData.contactPerson2Email ? userData.contactPerson2Email : "",
            Designation2: userData.contactPerson2Designation ? userData.contactPerson2Designation : "",
            DesignationOthers2: userData.DesignationOthers2 ? userData.DesignationOthers2 : "",
            Role2: userData.contactPerson2Role ? userData.contactPerson2Role : "",
            // ContactPerson3: userData.contactPerson3Name ? userData.contactPerson3Name : "",
            // EmailID3: userData.contactPerson3Email ? userData.contactPerson3Email : "",
            // MobileNumber3: userData.contactPerson3Mobile ? userData.contactPerson3Mobile : "",
            // Designation3: userData.contactPerson3Designation ? userData.contactPerson3Designation : "",
            // DesignationOthers3: userData.DesignationOthers3 ? userData.DesignationOthers3 : "",
            // Role3: userData.contactPerson3Role ? userData.contactPerson3Role : "",
            PGName: userData.pgName ? userData.pgName : "",
            PGType: userData.pgType ? userData.pgType : "",
            // Latitude: isUpdate ? userData.latitude ? userData.latitude : "" : position?.latitude ? `${position.latitude}` : "",
            // Longitude: isUpdate ? userData.longitude ? userData.longitude : "" : position?.longitude ? `${position.longitude}` : "",
            Latitude: position?.latitude ? `${position.latitude}` : "",
            Longitude: position?.longitude ? `${position.longitude}` : "",
            TenantType: userData.tenantType ? userData.tenantType : "",
            Designation: selectContactDesignation?.value ? selectContactDesignation.value : "",
            DesignationOthers: userData.DesignationOthers ? userData.DesignationOthers : "",
            Role: selectRole?.value ? selectRole.value : "",
            NumberofRooms: userData.numberOfRooms ? userData.numberOfRooms : "0",
            NumberofBeds: userData.numberOfBeds ? userData.numberOfBeds : "0",
            PerBedRent: userData.perBedRent ? userData.perBedRent : "0",
            ExistingInternetProvider: userData.existingInternetProvider ? userData.existingInternetProvider : "",
            ExistingInternetProviderOther: userData.existingInternetProvider === "111260005" ? userData.specificExistingInternetProvider : "",
            ExistingInternetOutflowPerMonth: userData.existingInternetOutflow ? userData.existingInternetOutflow : "",
            ExistingInternetOutflowPerMonthOther: userData.existingInternetOutflow === "111260007" ? userData.existingInternetOutflowOther : "",
            CurrentInfra: userData.currentInfra ? userData.currentInfra : "",
            CurrentInfraOther: userData.currentInfraOther ? userData.currentInfraOther : "",
            GoogleRatings: userData.googleRatings ? userData.googleRatings : "0",
            PGInternetRatings: userData.pgInternetRatings ? userData.pgInternetRatings : "0",
            Typeofproperty: selectTypeofproperty?.value ? selectTypeofproperty.value : "",
            DurationofLease: userData.lease ? userData.lease : "",
            PoorCustomerReviews: "",
            TenantComplaints: "",
            TenantChurn: "",
            PoorCustomerSupportfromexistingvendor: "",
            MultipleVendors: "",
            NewBuilding: "",
            FrequentDowntime: userData.painPoints?.includes("FrequentDowntime") ? "1" : "0",

            SpeedPerformance: userData.painPoints?.includes("SpeedPerformance") ? "1" : "0",

            HighLatency: userData.painPoints?.includes("HighLatency") ? "1" : "0",

            BillingDiscrepancies: userData.painPoints?.includes("BillingDiscrepancies") ? "1" : "0",

            PoorServiceSupportSLAViolations: userData.painPoints?.includes("PoorServiceSupportSLAViolations") ? "1" : "0",

            LimitedScalabilityUpgradeChallenges: userData.painPoints?.includes("LimitedScalabilityUpgradeChallenges") ? "1" : "0",

            SecurityConcernsComplianceIssues: userData.painPoints?.includes("SecurityConcernsComplianceIssues") ? "1" : "0",

            BadCoverageInfrastructureLimitations: userData.painPoints?.includes("BadCoverageInfrastructureLimitations") ? "1" : "0",

            NoRedundancybackuplink: userData.painPoints?.includes("NoRedundancybackuplink") ? "1" : "0",

            NoMonitoringUsageReport: userData.painPoints?.includes("NoMonitoringUsageReport") ? "1" : "0",
            UrgentTriggers: userData.urgentTriggers ? userData.urgentTriggers : "",
            SpectraRelationship: userData.spectraRelationship ? userData.spectraRelationship : "",
            ExistingConnectivity: selectExistConnectivity?.value ? selectExistConnectivity.value : "",
            Barriers: selectBarrier?.value ? selectBarrier.value : "",
            EmployeeCount: officeEmpCount?.value ? officeEmpCount.value : "",
            OfficeArea: coverageAreaRange?.value ? coverageAreaRange.value : "",
            Applications: selectApplications?.value ? selectApplications.value : "",
            ProductName: selectProductName?.value ? selectProductName.value : "",
            remark: finalRemark ? finalRemark : "",
            society: "",
            source: selectLeadSource?.value ? selectLeadSource.value : "Other",
            specifyArea: userData.specificArea ? userData.specificArea : "",
            specifybuilding: userData.specificBuilding ? userData.specificBuilding : "",
            state: selectState?.value ? selectState.value : "",
            statusReason: selectStatusReason?.value ? selectStatusReason.value : "",

            "Personmetname": userData.contactPerson3Name ? userData.contactPerson3Name : "",
            "Personmetmobilenumber": userData.contactPerson3Mobile ? userData.contactPerson3Mobile : "",
            "PersonmetEmailID": userData.contactPerson3Email ? userData.contactPerson3Email : "",
            "Personmetdesignation": userData.contactPerson3Designation ? userData.contactPerson3Designation : "",
            NoofFloors: userData.NoofFloors ? userData.NoofFloors : "",
            RoomsPerFloor: userData.RoomsPerFloor ? userData.RoomsPerFloor : "",
            "MraUser": "True",
            "BuildingNoPlotNo": userData?.buildingNoPlotNo,
            "BuildingType": selectBuildingType?.value ? selectBuildingType?.value : "",
            "Block": userData?.block,
            "Floor": userData?.floor,
            "Street": userData?.street,
            "Locality": userData?.locality,
            "LandmarkIfAny": userData?.landmarkIfAny,
            "PinCode": userData?.pinCode,
             "Doesthecustomerneedastaticip": "",
            userName: sessionStorage.getItem("userName") ? sessionStorage.getItem("userName") : "",
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            const leadCreated = data.Status === "Success" && selectStatusReason?.value === "111260002";

            if (data.Status === "Success") {
                toast.success(
                    leadCreated
                        ? "Lead Created Successfully"
                        : isUpdate
                            ? "Contact updated Successfully"
                            : "Contact created Successfully",
                    { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 }
                );

                navigate(
                    leadCreated
                        ? "/businessBdrPgAllContact"
                        : isUpdate
                            ? "/businessBdrPgAllContact"
                            : "/businessBdrPgAllContact"
                );
            } else {
                toast.warning(data.Response.Message, { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
            }


        } catch (error) {
            console.error("Error creating/updating contact:", error);
            toast.error("An error occurred. Please try again later.", { position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500 });
        } finally {
            setIsLoading(false);
        }
    };





    const handleDateTimeChange = (dateTime) => {
        setSelectedDateTime(dateTime);
        // console.log("setSelectedDateTime :",setSelectedDateTime)
    };


    const handleIconClick = (formId) => {
        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };

    const navigate = useNavigate();
    const redirectContactManagement = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/businessBdrPgAllContact");
            } else {
                if (ContactId) {
                    navigate(`/businessBdrContactFormPg?ContactId=${ContactId}`);
                } else {
                    navigate("/businessBdrContactFormPg");
                }
            }
        });
    };
    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectContactManagement}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    {ContactId ? (
                        <span className="p-1 m-3">Update Contact</span>
                    ) : (
                        <span className="p-1 m-3">Contact Management</span>
                    )}
                </div>
            </div>
            <div className="container-fluid form-container">
                {isLoading && (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={loader} alt="loading...."></img>
                        </div>
                    </div>
                )}
                {meetingcounter >= 1 && (
                    <>
                        {/* {(selectStatusReason.value !== "Lead Created/Closed" && selectStatusReason.value !== "Disqualified") &&
                            <div>
                                {!showForm ? (
                                    <button
                                        type="button"
                                        className="btn btn-dark w-100 mt-2 btn text-light"
                                        onClick={() => setShowForm(true)}
                                    >
                                        Disqualify
                                    </button>

                                ) : (
                                    <>
                                        <Select
                                            isMulti
                                            options={optionQualify}
                                            value={selectedReasons}
                                            onChange={handleChanged}
                                            styles={customStyles}
                                            components={{ MultiValueRemove }}
                                            className="basic-multi-select disqualify-select"
                                            classNamePrefix="select"
                                            placeholder="Select Disqualify Reason(s)..."
                                            isSearchable={false}
                                        />
                                        <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                            <button
                                                type="button"
                                                className="btn text-light bg-dark rounded-pill submit-btn"
                                                onClick={handleDisqualify}
                                                disabled={!selectedReasons.length}
                                            >
                                                Disqualify
                                            </button>
                                            <button
                                                type="button"
                                                className="btn text-light bg-dark rounded-pill submit-btn"
                                                onClick={() => setShowForm(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                    </>
                                )}
                            </div>
                            } */}

                        {/* {barrierstatus === "3" && selectStatusReason.value === "Contacted" && (
                            <button
                                className="btn w-100 mt-2 qualify-btn text-light"
                                onClick={handleQualify}
                            >
                                Qualify
                            </button>
                        )} */}
                    </>
                )}

                {/* {console.log(" {selectStatusReason ", selectStatusReason)} */}
                <div className="container-fluid form-container">
                    {isFiltered ? (
                        <>
                            <div
                                className="contact-toggle"

                            >
                                <span className="toggle-text">Contact Details</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>


                            <form className="contact-form p-2">


                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder=""
                                        className="form-control input-text form-control-sm mt-1"
                                        id="pgName"
                                        name="pgName"
                                        value={userData.pgName}
                                        onChange={handleChange}
                                        style={{ background: "transparent" }}
                                    />
                                    <label htmlFor="pgName" className="mt-2">Name of PG*</label>
                                </div>


                                <div className="input-box form-floating"
                                    style={{ position: "relative", paddingTop: "4px" }}
                                >
                                    <input
                                        type="text"
                                        placeholder="latitude"
                                        className="form-control input-text form-control-sm mt-1"
                                        id="latitude"
                                        name="latitude"
                                        disabled
                                        value={userData.latitude || ""}
                                        readOnly={true}
                                        style={{ background: "transparent" }}
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="latitude" className="mt-2">Latitude</label>
                                </div>
                                <div className="input-box form-floating"
                                    style={{ position: "relative", paddingTop: "4px" }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Longitude"
                                        className="form-control input-text form-control-sm mt-1"
                                        id="longitude"
                                        name="longitude"
                                        disabled
                                        value={userData.longitude || ""}
                                        readOnly={true}
                                        style={{ background: "transparent" }}
                                    />
                                    <i
                                        className="fa-solid fa-lock text-secondary"
                                        style={{
                                            position: "absolute",
                                            right: "20px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                        }}
                                    ></i>
                                    <label htmlFor="longitude" className="mt-2">Longitude</label>
                                </div>
                                <div className="">
                                    <label className="select-search-label mt-1">Barriers*</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        name="selectBarrier"
                                        value={selectBarrier}
                                        options={optionBarrier.map((d) => ({ value: d.value, label: d.label }))}
                                        onChange={handleSelectBarrier}
                                        isSearchable={false}
                                    />
                                </div>
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        id="spectraRFS"
                                        name="spectraRFS"
                                        className="form-control input-text form-control-sm mt-1"
                                        value={userData.spectraRFS || ''}
                                        onChange={handleChange}
                                        disabled
                                        style={{ background: 'transparent' }}
                                    />
                                    <label htmlFor="spectraRFS" className="mt-2">Spectra RFS</label>
                                </div>



                                <form className="Installation-form p-2">
                                    <div className="">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="state"
                                            placeholder="Select State"
                                            isSearchable
                                            styles={style}
                                            value={selectState}
                                            onChange={handleSelectState}
                                            isDisabled={
                                                ContactId && checkStatusReason == "Lead Created/Closed"
                                            }
                                            options={optionState.map((data) => ({
                                                value: data.code,
                                                label: data.name,
                                            }))}
                                        />
                                    </div>

                                    {/* {console.log("selectCity", selectCity)} */}
                                    <div className="">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="City"
                                            placeholder="Select City"
                                            isSearchable
                                            isDisabled={
                                                ContactId && checkStatusReason == "Lead Created/Closed"
                                            }
                                            styles={style}
                                            // value={cityType.find((city) => city.CityCode === selectCity.value)}
                                            value={selectCity}
                                            onChange={handleSelectCity}
                                            options={cityType.map((data) => ({
                                                value: data.CityCode,
                                                label: data.CityName,
                                            }))}
                                        />
                                    </div>

                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Area*</label>
                                        <Select
                                            options={areaList.map((area) => ({
                                                value: area.AreaCode,
                                                label: `${area.AreaName} (${area.AreaCode})`,
                                            }))}
                                            className="basic-single form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            styles={style}
                                            isSearchable
                                            value={selectArea}
                                            isDisabled={
                                                ContactId && checkStatusReason == "Lead Created/Closed"
                                            }
                                            onChange={handleSelectArea}
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>

                                    {/* {console.log("selectArea", selectArea)} */}




                                    {
                                        selectArea &&
                                            selectArea.label.includes("Other") ? (
                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder=""
                                                    className=" form-control input-text form-control-sm mt-1"
                                                    id="specificArea"
                                                    name="specificArea"
                                                    value={userData.specificArea}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="floatingInput" className="mt-2">
                                                    Specific Area Name
                                                </label>
                                            </div>
                                        ) : null}

                                    <div className="search-building" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Building*</label>
                                        <Select
                                            options={buildingList.map((building) => ({
                                                value: building.BuildingCode,
                                                label: `${building.BuildingName} (${building.BuildingCode})`,
                                            }))}
                                            className="basic-single form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Building"
                                            styles={style}
                                            isSearchable
                                            value={selectBuilding}
                                            isDisabled={
                                                ContactId && checkStatusReason == "Lead Created/Closed"
                                            }
                                            onChange={(selectedOption) =>
                                                setSelectBuilding(selectedOption)
                                            }
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>

                                    {/* {console.log("selectBuilding", selectBuilding)} */}

                                    {
                                        selectBuilding &&
                                            selectBuilding.label.includes("Other") ? (
                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder=""
                                                    className=" form-control input-text form-control-sm mt-1"
                                                    id="specificBuilding"
                                                    name="specificBuilding"
                                                    value={userData.specificBuilding}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor="floatingInput" className="mt-2">
                                                    Specific Building Name
                                                </label>
                                            </div>
                                        ) : null}

                                    <div className="">
                                        <label className="select-search-label mt-1">Building Type*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="subBusiness"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectBuildingType}
                                            isSearchable={false}
                                            onChange={handleSelectBuildingType}
                                            options={optionBuildingType.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="buildingNoPlotNo"
                                            name="buildingNoPlotNo"
                                            value={userData.buildingNoPlotNo}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Building No./Plot No.*
                                        </label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="block"
                                            name="block"
                                            value={userData.block}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Block*
                                        </label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="floor"
                                            name="floor"
                                            value={userData.floor}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Floor*
                                        </label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="street"
                                            name="street"
                                            value={userData.street}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Street Name*
                                        </label>
                                    </div>

                                    {/* <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="locality"
                                            name="locality"
                                            value={userData.locality}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Locality*
                                        </label>
                                    </div> */}

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="landmarkIfAny"
                                            name="landmarkIfAny"
                                            value={userData.landmarkIfAny}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Landmark If Any*
                                        </label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="pinCode"
                                            name="pinCode"
                                            value={userData.pinCode}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key)) &&
                                                    (userData.pinCode.length < 6 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Pin Code*
                                        </label>
                                    </div>
                                </form>


                                <div className="text-center mt-5 mb-5">
                                    <button
                                        type="button"

                                        className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </form>
                            {/* </div> */}
                            {/* //     </> */}
                            {/* // )} */}
                        </>
                    ) : (
                        /* -------------------------------------------------------
                           DEFAULT LAYOUT: your original form1/form2/form3/forms and save button
                           ------------------------------------------------------- */
                        <>
                            <div
                                className="contact-toggle"
                                onClick={() => handleIconClick("form1")}
                            >
                                <span className="toggle-text">Contact Information</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>

                            {activeForm === "form1" && (
                                <div
                                    className=" container shadow mb-3 bg-body rounded mt-4"
                                    id="form1"
                                >
                                    {/* *********Contact Information form******** */}
                                    <form className=" contact-form p-2">
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="pgName"
                                                name="pgName"
                                                value={userData.pgName}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="pgName" className="mt-2">Name of PG*</label>
                                        </div>

                                        <div>
                                            <label className="select-search-label mt-1">Barriers*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="selectBarrier"
                                                placeholder="Select Option"
                                                styles={style}
                                                value={selectBarrier}
                                                isSearchable={false}
                                                isDisabled={barrierstatus === "2"}      // ← disable when status is "3"
                                                onChange={handleSelectBarrier}
                                                options={optionBarrier.map(data => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div>
                                        <div className="select-container mt-2">
                                            <label className="select-search-label">PG Type*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="pgType"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectPGType}
                                                isSearchable={false}
                                                onChange={handleSelectPGType}
                                                options={[
                                                    { value: "111260000", label: "Men" },
                                                    { value: "111260001", label: "Women" },
                                                    { value: "111260002", label: "Hybrid" },
                                                ]}
                                            />
                                        </div>

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Tenant Type*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="tenantType"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectTenantType}
                                                isSearchable={false}
                                                onChange={handleSelectTenantType}
                                                options={[
                                                    { value: "111260000", label: "Professional" },
                                                    { value: "111260001", label: "Student" },
                                                    { value: "111260002", label: "Hybrid" },

                                                ]}
                                            />
                                        </div>
                                        <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="fullName"
                                                name="fullName"
                                                value={userData.fullName}
                                                onChange={handleChange}
                                                readOnly={true}
                                                style={{ background: "transparent" }}
                                            />
                                            <i
                                                className="fa-solid fa-lock text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "65%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                            <label htmlFor="floatingInput" className="m-0">
                                                Full Name
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="firstName"
                                                name="firstName"
                                                value={userData.firstName}
                                                onChange={handleChange}
                                                disabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                First Name*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="lastName"
                                                name="lastName"
                                                value={userData.lastName}
                                                onChange={handleChange}
                                                disabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Last Name*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                id="mobileOne"
                                                name="mobileOne"
                                                disabled={
                                                    // !fieldsEditable ||
                                                    (ContactId && checkStatusReason == "Lead Created/Closed")
                                                }
                                                value={userData.mobileOne}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (userData.mobileOne.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Mobile Number*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="mobileTwo"
                                                name="mobileTwo"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                disabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                style={{ background: "transparent" }}
                                                value={userData.mobileTwo}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (userData.mobileTwo.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Mobile Number 2
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="email"
                                                name="email"
                                                disabled={
                                                    // !fieldsEditable ||
                                                    (ContactId && checkStatusReason == "Lead Created/Closed")
                                                }
                                                value={userData.email}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                onBlur={handleEmailBlur}

                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Email ID
                                            </label>
                                        </div>
                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Role*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="role"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectRole}
                                                isSearchable={false}
                                                onChange={handleSelectRole}
                                                options={[
                                                    { value: "111260000", label: "KDM" },
                                                    { value: "111260001", label: "Influencer" },
                                                ]}
                                            />
                                        </div>

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Contact Designation*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="contactDesignation"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectContactDesignation}
                                                isSearchable={false}
                                                onChange={handleSelectContactDesignation}
                                                options={[
                                                    { value: "111260000", label: "Owner" },
                                                    { value: "111260001", label: "Manager" },
                                                    { value: "111260002", label: "CareTaker" },
                                                    { value: "111260003", label: "Other" },
                                                    // { label: "Select Option", value: "0" },
                                                    // { label: "Admin Manager", value: "111260004" },
                                                    // { label: "IT / Network Manager", value: "111260005" },
                                                    // { label: "Other", value: "111260003" },
                                                ]}
                                            />
                                        </div>
                                        {selectContactDesignation?.label == "Other" && (<div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Designation"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="DesignationOthers"
                                                name="DesignationOthers"
                                                value={userData.DesignationOthers || ""}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="company" className='mt-2'>Specific Designation*</label>
                                        </div>)}

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                id="contactPerson2Name"
                                                name="contactPerson2Name"
                                                value={userData.contactPerson2Name}
                                                onChange={handleChange}
                                                className="form-control input-text form-control-sm mt-1"
                                                placeholder=""
                                            />
                                            <label htmlFor="contactPerson2Name" className="mt-2">
                                                Contact Person 2 Name
                                            </label>
                                        </div>

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Contact Person 2 Designation</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="contactPerson2Designation"
                                                value={selectContact2Designation}
                                                onChange={handleSelectContact2Designation}
                                                styles={style}

                                                options={[
                                                    { value: "111260000", label: "Owner" },
                                                    { value: "111260001", label: "Manager" },
                                                    { value: "111260002", label: "CareTaker" },
                                                    { value: "111260003", label: "Other" },
                                                    // { label: "Select Option", value: "0" },
                                                    // { label: "Admin Manager", value: "111260004" },
                                                    // { label: "IT / Network Manager", value: "111260005" },
                                                    // { label: "Other", value: "111260003" },
                                                ]}
                                            />
                                        </div>
                                        {selectContact2Designation?.label == "Other" && (<div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Designation2"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="DesignationOthers2"
                                                name="DesignationOthers2"
                                                value={userData.DesignationOthers2 || ""}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="company" className='mt-2'>Specific Designation 2*</label>
                                        </div>)}
                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                id="contactPerson2Mobile"
                                                name="contactPerson2Mobile"
                                                value={userData.contactPerson2Mobile}
                                                onChange={handleChange}
                                                className="form-control input-text form-control-sm mt-1"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                        // && (userData.mobileTwo.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="contactPerson2Mobile" className="mt-2">
                                                Contact Person 2 Mobile Number
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                id="contactPerson2Email"
                                                name="contactPerson2Email"
                                                value={userData.contactPerson2Email}
                                                onChange={handleChange}
                                                className="form-control input-text form-control-sm mt-1"
                                                placeholder=""
                                                onBlur={handleEmailBlur}

                                            />
                                            <label htmlFor="contactPerson2Email" className="mt-2">
                                                Contact Person 2 Email ID
                                            </label>
                                        </div>

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Contact Person 2 Role</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="contactPerson2Role"
                                                value={selectContact2Role}
                                                styles={style}

                                                onChange={handleSelectContact2Role}
                                                options={[
                                                    { value: "111260000", label: "KDM" },
                                                    { value: "111260001", label: "Influencer" },
                                                ]}
                                            />
                                        </div>
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                id="contactPerson3Name"
                                                name="contactPerson3Name"
                                                value={userData.contactPerson3Name}
                                                disabled={
                                                    otpContactStatus === "Contact - Valid"
                                                }
                                                style={{ background: "transparent" }}

                                                onChange={handleChange}
                                                className="form-control input-text form-control-sm mt-1"
                                                placeholder=""
                                            />
                                            <label htmlFor="contactPerson3Name" className="mt-2">
                                                Person Met Name
                                            </label>
                                        </div>

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Person Met Designation</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="contactPerson3Designation"
                                                value={selectContact3Designation}
                                                isDisabled={
                                                    otpContactStatus === "Contact - Valid"
                                                }
                                                onChange={handleSelectContact3Designation}
                                                styles={style}

                                                options={[
                                                    { value: "111260000", label: "Owner" },
                                                    { value: "111260001", label: "Manager" },
                                                    { value: "111260002", label: "CareTaker" },
                                                    { value: "111260003", label: "Other" },
                                                    // { label: "Select Option", value: "0" },
                                                    // { label: "Admin Manager", value: "111260004" },
                                                    // { label: "IT / Network Manager", value: "111260005" },
                                                    // { label: "Other", value: "111260003" },
                                                ]}
                                            />
                                        </div>
                                        {selectContact3Designation?.label == "Other" && (<div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Designation2"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="DesignationOthers3"
                                                name="DesignationOthers3"
                                                disabled={
                                                    otpContactStatus === "Contact - Valid"
                                                }
                                                style={{ background: "transparent" }}

                                                value={userData.DesignationOthers3 || ""}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="company" className='mt-2'>Specific Designation *</label>
                                        </div>)}

                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                id="contactPerson3Mobile"
                                                name="contactPerson3Mobile"
                                                value={userData.contactPerson3Mobile}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}

                                                className="form-control input-text form-control-sm mt-1"
                                                maxLength="10"
                                                disabled={!fieldsEditable ||
                                                    otpContactStatus === "Contact - Valid"
                                                }
                                                placeholder=""
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                        // && (userData.mobileTwo.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="contactPerson3Mobile" className="mt-2">
                                                Person Met Mobile Number
                                            </label>
                                        </div>
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                id="contactPerson3Email"
                                                name="contactPerson3Email"
                                                value={userData.contactPerson3Email}
                                                onChange={handleChange}
                                                disabled={!fieldsEditable ||
                                                    otpContactStatus === "Contact - Valid"
                                                }
                                                style={{ background: "transparent" }}
                                                className="form-control input-text form-control-sm mt-1"
                                                placeholder=""
                                                onBlur={handleEmailBlur}

                                            />
                                            <label htmlFor="contactPerson3Email" className="mt-2">
                                                Person Met Email ID
                                            </label>
                                        </div>

                                        {/* <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                id="contactPerson3Email"
                                                name="contactPerson3Email"
                                                value={userData.contactPerson3Email}
                                                onChange={handleChange}
                                                className="form-control input-text form-control-sm mt-1"
                                                placeholder=""
                                                onBlur={handleEmailBlur}

                                            />
                                            <label htmlFor="contactPerson3Email" className="mt-2">
                                                Contact Person 3 Email ID
                                            </label>
                                        </div> */}

                                        {/* <div className="select-container mt-2">
                                            <label className="select-search-label">Contact Person 3 Role</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="contactPerson3Role"
                                                styles={style}

                                                value={selectContact3Role}
                                                onChange={handleSelectContact3Role}
                                                options={[
                                                    { value: "111260000", label: "KDM" },
                                                    { value: "111260001", label: "Influencer" },
                                                ]}
                                            />
                                        </div> */}

                                        {/* <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="pgName"
                                                name="pgName"
                                                value={userData.pgName}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="pgName" className="mt-2">Name of PG*</label>
                                        </div> */}

                                        <div className="select-container mt-2">
                                            <label className="select-search-label">Type of property</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="tenantType"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectTypeofproperty}
                                                isSearchable={false}
                                                onChange={handleTypeofproperty}
                                                options={[
                                                    { value: "111260000", label: "Leased" },
                                                    { value: "111260001", label: "Owned" },
                                                ]}
                                            />
                                        </div>
                                        {selectTypeofproperty?.value === "111260000" && (

                                            <div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="lease"
                                                    name="lease"
                                                    value={userData.lease}
                                                    onChange={handleChange1}
                                                    // onBlur={handleBlur}


                                                    style={{ background: "transparent" }}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = [
                                                            "Backspace",
                                                            "Delete",
                                                            "ArrowLeft",
                                                            "ArrowRight",
                                                            "Tab",
                                                        ];
                                                        const isDigit = /\d/.test(e.key);
                                                        if (
                                                            (isDigit || allowedKeys.includes(e.key))
                                                            //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                        ) {
                                                            return true;
                                                        } else {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                // max="50"
                                                />
                                                <label htmlFor="lease" className="mt-2">Duration of Lease (Years)</label>
                                            </div>
                                        )}
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="numberOfRooms"
                                                name="numberOfRooms"
                                                value={userData.numberOfRooms}
                                                onChange={handleChange1}
                                                // onBlur={handleBlur}


                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                        //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            // max="50"
                                            />
                                            <label htmlFor="numberOfRooms" className="mt-2">Number of Rooms*</label>
                                        </div>


                                        <div className="input-box form-floating">
                                            <input
                                                type="text"

                                                onKeyDown={(e) => {

                                                    const allowedKeys = [

                                                        "Backspace",

                                                        "Delete",

                                                        "ArrowLeft",

                                                        "ArrowRight",

                                                        "Tab",

                                                    ];

                                                    const isDigit = /\d/.test(e.key);

                                                    if (

                                                        (isDigit || allowedKeys.includes(e.key))

                                                        //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                    ) {

                                                        return true;

                                                    } else {

                                                        e.preventDefault();

                                                    }

                                                }}

                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="numberOfBeds"
                                                name="numberOfBeds"
                                                value={userData.numberOfBeds}
                                                onChange={handleChange1}
                                                // onBlur={handleBlur}

                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="numberOfBeds" className="mt-2">Number of Beds*</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"

                                                onKeyDown={(e) => {

                                                    const allowedKeys = [

                                                        "Backspace",

                                                        "Delete",

                                                        "ArrowLeft",

                                                        "ArrowRight",

                                                        "Tab",

                                                    ];

                                                    const isDigit = /\d/.test(e.key);

                                                    if (

                                                        (isDigit || allowedKeys.includes(e.key))

                                                        //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                    ) {

                                                        return true;

                                                    } else {

                                                        e.preventDefault();

                                                    }

                                                }}

                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="perBedRent"
                                                name="perBedRent"
                                                value={userData.perBedRent}
                                                onChange={handleChange1}
                                                // onBlur={handleBlur}

                                                style={{ background: "transparent" }}
                                            // step="0.01"
                                            />
                                            <label htmlFor="perBedRent" className="mt-2">Per Bed Rent*</label>
                                        </div>

                                        {/* <div className="">
                                            <label className="select-search-label mt-1">
                                                Employee Count*
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="officeEmpCount"
                                                placeholder="Select Option"
                                                styles={style}
                                                value={officeEmpCount}
                                                isSearchable={false}
                                                onChange={handleSelectOfficeEmpCount}
                                                options={optionOfficeEmpCount.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div> */}


                                        {/* {ContactId && ( */}
                                        {/* <div className="">
                                            <label className="select-search-label mt-1">
                                                Coverage Area Range
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="coverageAreaRange"
                                                placeholder="Select Option"
                                                styles={style}
                                                value={coverageAreaRange}
                                                isSearchable={false}
                                                onChange={handleSelectCoverageAreaRange}
                                                options={optionCoverageAreaRange.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div> */}
                                        {/* )} */}

                                        {/* Current Infra currentInfraOther */}
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Designation2"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="currentInfraOther"
                                                name="currentInfraOther"
                                                styles={style}
                                                value={userData.currentInfraOther || ""}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="company" className='mt-2'>Current Infra</label>
                                        </div>
                                        {/* <div className="select-container mt-2">
                                            <label className="select-search-label">Current Infra</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="currentInfra"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectCurrentInfra}
                                                isSearchable={false}
                                                onChange={handleSelectCurrentInfra}
                                                options={[
                                                    // Placeholder options; adjust these based on your requirements.
                                                    { value: "111260000", label: "Broadband" },
                                                    { value: "111260001", label: "Access Points" },
                                                    // { value: "111260002", label: "Others" },
                                                ]}
                                            />
                                        </div> */}
                                        {/* {ContactId && (
                                            <>
                                                <div className="">
                                                    <label className="select-search-label mt-1">
                                                        Applications
                                                    </label>
                                                    <Select
                                                        className=" basic-single form-control form-control-sm p-1"
                                                        classNamePrefix="select"
                                                        name="selectApplications"
                                                        placeholder="Select Option"
                                                        styles={style}
                                                        value={selectApplications}
                                                        isSearchable={false}
                                                        onChange={handleSelectApplications}
                                                        options={optionApplications.map((data) => ({
                                                            value: data.value,
                                                            label: data.label,
                                                        }))}
                                                    />
                                                </div>
                                            </>
                                        )} */}
                                        {/* <div className="select-container mt-2">
                                            <label className="select-search-label">Lead Channel*</label>
                                            <Select
                                                className=" basic-single form-control form-control-sm  p-1"
                                                classNamePrefix="select"
                                                name="leadChannel"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectLeadChannel}
                                                isSearchable={false}
                                                onChange={handleSelectLead}
                                                isDisabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                options={optionLeadChannel.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div> */}



                                        <div className="input-box form-floating"
                                            style={{ position: "relative", paddingTop: "5px" }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="latitude"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="latitude"
                                                name="latitude"
                                                disabled
                                                value={userData.latitude || ""}
                                                readOnly={true}
                                                style={{ background: "transparent" }}
                                            />
                                            <i
                                                className="fa-solid fa-lock text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                            <label htmlFor="latitude" className="m-0">Latitude</label>
                                        </div>
                                        <div className="input-box form-floating"
                                            style={{ position: "relative", paddingTop: "5px" }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Longitude"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="longitude"
                                                name="longitude"
                                                disabled
                                                value={userData.longitude || ""}
                                                readOnly={true}
                                                style={{ background: "transparent" }}
                                            />
                                            <i
                                                className="fa-solid fa-lock text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                            <label htmlFor="longitude" className="m-0">Longitude</label>
                                        </div>

                                        {/* </>
                                    )} */}


                                        {ContactId && (
                                            <div className="select-container mt-2">
                                                <label className="select-search-label">Status Reason*</label>
                                                <Select
                                                    className=" basic-single form-control form-control-sm  p-1"
                                                    classNamePrefix="select"
                                                    name="Reason"
                                                    placeholder="Select"
                                                    styles={style}
                                                    value={selectStatusReason}
                                                    readonly
                                                    isSearchable={false}
                                                    onChange={handleSelectStatusReason}
                                                    isDisabled
                                                    options={optionStatusReason.map((data) => ({
                                                        value: data.value,
                                                        label: data.label,
                                                    }))}
                                                />
                                            </div>
                                        )}


                                        {/* dateTime picker calender */}
                                        {selectStatusReason.label === "Scheduled for Appointment" && (
                                            <div>
                                                <label className="select-search-label mt-1">Follow Up Date/Time</label>
                                                <StyledEngineProvider>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer components={["MobileDateTimePicker"]}>
                                                            <MobileDateTimePicker
                                                                value={selectedDateTime}
                                                                onChange={handleDateTimeChange}
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </StyledEngineProvider>
                                            </div>)}


                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                id="NoofFloors"
                                                name="NoofFloors"
                                                // disabled={
                                                //     !fieldsEditable ||
                                                //     (ContactId && checkStatusReason == "Lead Created/Closed")
                                                // }
                                                value={userData.NoofFloors}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (userData.NoofFloors.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                No of Floors*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="tel"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                maxLength="10"
                                                pattern="[0-9]{10}"
                                                id="RoomsPerFloor"
                                                name="RoomsPerFloor"
                                                // disabled={
                                                //     !fieldsEditable ||
                                                //     (ContactId && checkStatusReason == "Lead Created/Closed")
                                                // }
                                                value={userData.RoomsPerFloor}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (userData.RoomsPerFloor.length < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Rooms Per Floor*
                                            </label>
                                        </div>


                                        {/* <div className="">
                                            <label className="select-search-label mt-1">
                                                Industry Segment
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="industryType"
                                                placeholder="Select IndustryType"
                                                styles={style}
                                                value={selectIndustryType}
                                                isSearchable={false}
                                                onChange={handleSelectIndustryType}
                                                options={industryTypes.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div>  */}

                                        {/* <div className="select-container mt-2">
                                            <label className="select-search-label">Industry Segment*</label>
                                            <Select
                                                className=" basic-single form-control form-control-sm  p-1"
                                                classNamePrefix="select"
                                                name="industrySegment"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectIndustrySegment}
                                                isSearchable={false}
                                                onChange={handleSelectIndustrySegment}
                                                options={optionIndustrySegment.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div> */}

                                        {ContactId &&
                                            otpContactStatus !== "Contact - Valid" &&
                                            (
                                                otpContactStatus !== "111260000" ? (
                                                    <div className="input-box form-floating mb-3">
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="otp"
                                                            name="otp"
                                                            maxLength="4"
                                                            // pattern="[0-9]{10}"
                                                            value={userData.otp}
                                                            onChange={handleChange}
                                                        // onKeyDown={(e) => {
                                                        //     const allowedKeys = [
                                                        //         "Backspace",
                                                        //         "Delete",
                                                        //         "ArrowLeft",
                                                        //         "ArrowRight",
                                                        //         "Tab",
                                                        //     ];
                                                        //     const isDigit = /\d/.test(e.key);
                                                        //     const inputOtpLength = userData.otp ? userData.otp.length : 0;
                                                        //     if (
                                                        //         (isDigit || allowedKeys.includes(e.key)) &&
                                                        //         //    (userData.otp.length < 6 || e.key === "Backspace")
                                                        //         (inputOtpLength < 6 || e.key === "Backspace")
                                                        //     ) {
                                                        //         return true;
                                                        //     } else {
                                                        //         e.preventDefault();
                                                        //     }
                                                        // }}
                                                        />
                                                        <label htmlFor="floatingInput" className="mt-2">
                                                            Happy Code
                                                        </label>
                                                    </div>
                                                ) : null
                                            )}
                                        {/* {ContactId &&

                                            otpContactStatus !== "111260000" &&
                                            otpContactStatus !== "Contact - Valid" ? (


                                            <div className="input-box form-floating">
                                                <input
                                                    type="tel"
                                                    placeholder=""
                                                    className=" form-control input-text form-control-sm mt-1"
                                                    value={userData.otp}
                                                    id="otp"
                                                    name="otp"
                                                    maxLength="6"
                                                    pattern="[0-9]{10}"
                                                    onChange={handleChange}
                                                    style={{ background: "transparent" }}
                                                    onKeyDown={(e) => {
                                                        const allowedKeys = [
                                                            "Backspace",
                                                            "Delete",
                                                            "ArrowLeft",
                                                            "ArrowRight",
                                                            "Tab",
                                                        ];
                                                        const isDigit = /\d/.test(e.key);
                                                        const inputOtpLength = userData.otp ? userData.otp.length : 0;
                                                        if (
                                                            (isDigit || allowedKeys.includes(e.key)) &&
                                                            //    (userData.otp.length < 6 || e.key === "Backspace")
                                                            (inputOtpLength < 6 || e.key === "Backspace")

                                                        ) {
                                                            return true;
                                                        } else {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                                <label htmlFor="floatingInput" className="mt-2">
                                                    Happy Code
                                                </label>
                                            </div>
                                        ) : null
                                        } */}

                                        {/* {console.log("otpContactStatus", otpContactStatus)} */}



                                    </form>
                                </div>
                            )}
                            {ContactId && (
                                <>
                                    {/* <div
                                        className="Installation-toggle mt-3"
                                        onClick={() => handleIconClick("form2")}
                                    >
                                        <span className="toggle-text">Company Info</span>
                                        <span className=" float-end">
                                            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                        </span>
                                    </div> */}
                                    {/* ) : null} */}

                                    {activeForm === "form2" && (
                                        <div
                                            className=" container shadow mb-3 bg-body rounded mt-4"
                                            id="form2"
                                        >
                                            {/**********PG Info form******** */}
                                            <form className="contact-form pg-info-form p-2">

                                                <>

                                                    <div className="input-box form-floating">
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="spectraRFS"
                                                            name="spectraRFS"
                                                            disabled
                                                            value={userData.spectraRFS}
                                                            onChange={handleChange}
                                                            style={{ background: "transparent" }}
                                                        />
                                                        <label htmlFor="spectraRFS" className="mt-2">Spectra RFS</label>
                                                    </div>

                                                    {/* Existing Internet Provider */}
                                                    <div className="select-container mt-2">
                                                        <label className="select-search-label">Existing Internet Provider</label>
                                                        <Select
                                                            className="basic-single form-control form-control-sm p-1"
                                                            classNamePrefix="select"
                                                            name="existingInternetProvider"
                                                            placeholder="Select"
                                                            styles={style}
                                                            value={selectExistingInternetProvider}
                                                            isSearchable={false}
                                                            onChange={handleSelectExistingInternetProvider}
                                                            options={[
                                                                { value: "111260000", label: "Airtel" },
                                                                { value: "111260001", label: "Jio" },
                                                                { value: "111260002", label: "Tata" },
                                                                { value: "111260003", label: "ACT" },
                                                                { value: "111260004", label: "New Building" },
                                                                { value: "111260005", label: "Others" },
                                                            ]}
                                                        />
                                                    </div>
                                                    {selectExistingInternetProvider?.value == "111260005" &&
                                                        <div className="input-box form-floating">
                                                            <input
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control input-text form-control-sm mt-1"
                                                                id="specificExistingInternetProvider"
                                                                name="specificExistingInternetProvider"

                                                                value={userData.specificExistingInternetProvider}
                                                                onChange={handleChange}
                                                                style={{ background: "transparent" }}
                                                            />
                                                            <label htmlFor="pgInternetRatings" className="mt-2">Specific Existing Internet Provider</label>
                                                        </div>}

                                                    {/* Existing Internet Outflow Per Month */}
                                                    <div className="select-container mt-2">
                                                        <label className="select-search-label">Existing Internet Outflow Per Month</label>
                                                        <Select
                                                            className="basic-single form-control form-control-sm p-1"
                                                            classNamePrefix="select"
                                                            name="existingInternetOutflow"
                                                            placeholder="Select"
                                                            styles={style}
                                                            value={selectExistingInternetOutflow}
                                                            isSearchable={false}
                                                            onChange={handleSelectExistingInternetOutflow}
                                                            options={[
                                                                { value: "111260000", label: "<5000" },
                                                                { value: "111260001", label: "5001 - 10000" },
                                                                { value: "111260008", label: "10001 - 20000" },
                                                                { value: "111260009", label: ">20,000" },

                                                                { value: "111260006", label: "New Building" },
                                                                { value: "111260007", label: "Others" },
                                                            ]}
                                                        />
                                                    </div>
                                                    {selectExistingInternetOutflow?.value == "111260007" &&
                                                        <div className="input-box form-floating">
                                                            <input
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control input-text form-control-sm mt-1"
                                                                id="existingInternetOutflowOther"
                                                                name="existingInternetOutflowOther"

                                                                value={userData.existingInternetOutflowOther}
                                                                onChange={handleChange}
                                                                style={{ background: "transparent" }}
                                                            />
                                                            <label htmlFor="pgInternetRatings" className="mt-2">Specific Current Outflow Per Month</label>
                                                        </div>}

                                                    {/* Pain Points - Multi-Select */}
                                                    <div className="select-container mt-2">
                                                        <label className="select-search-label">Pain Points</label>
                                                        <Select
                                                            className="basic-multi-select form-control form-control-sm p-1"
                                                            classNamePrefix="select"
                                                            name="painPoints"
                                                            placeholder="Select"
                                                            styles={style}
                                                            value={selectPainPoints}
                                                            isMulti
                                                            onChange={handleSelectPainPoints}
                                                            options={[
                                                                { value: "FrequentDowntime", label: "Frequent Downtime" },
                                                                { value: "SpeedPerformance", label: "Speed Performance" },
                                                                { value: "HighLatency", label: "High Latency" },
                                                                { value: "BillingDiscrepancies", label: "Billing Discrepancies" },
                                                                { value: "PoorServiceSupportSLAViolations", label: "Poor Service Support / SLA Violations" },
                                                                { value: "LimitedScalabilityUpgradeChallenges", label: "Limited Scalability / Upgrade Challenges" },
                                                                { value: "SecurityConcernsComplianceIssues", label: "Security Concerns / Compliance Issues" },
                                                                { value: "BadCoverageInfrastructureLimitations", label: "Bad Coverage / Infrastructure Limitations" },
                                                                { value: "NoRedundancybackuplink", label: "No Redundancy / Backup Link" },
                                                                { value: "NoMonitoringUsageReport", label: "No Monitoring / Usage Report" },
                                                            ]}
                                                        />
                                                    </div>





                                                </>
                                                {/* // )} */}

                                            </form>
                                        </div>
                                    )}
                                </>
                            )}
                            <div
                                className="Installation-toggle mt-3"
                                onClick={() => handleIconClick("form3")}
                            >
                                <span className="toggle-text">Installation Address</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>

                            {activeForm === "form3" && (
                                <div
                                    className=" container shadow mb-3 bg-body rounded mt-4"
                                    id="form3"
                                >
                                    {/**********Installation Address form******** */}
                                    <form className="Installation-form p-2">
                                        <div className="">
                                            <label className="select-search-label mt-1">State*</label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="state"
                                                placeholder="Select State"
                                                isSearchable
                                                styles={style}
                                                value={selectState}
                                                onChange={handleSelectState}
                                                isDisabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                options={optionState.map((data) => ({
                                                    value: data.code,
                                                    label: data.name,
                                                }))}
                                            />
                                        </div>

                                        {/* {console.log("selectCity", selectCity)} */}
                                        <div className="">
                                            <label className="select-search-label mt-1">City*</label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="City"
                                                placeholder="Select City"
                                                isSearchable
                                                isDisabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                styles={style}
                                                // value={cityType.find((city) => city.CityCode === selectCity.value)}
                                                value={selectCity}
                                                onChange={handleSelectCity}
                                                options={cityType.map((data) => ({
                                                    value: data.CityCode,
                                                    label: data.CityName,
                                                }))}
                                            />
                                        </div>

                                        <div className="search-area" style={{ position: "relative" }}>
                                            <label className="select-search-label mt-1">Area*</label>
                                            <Select
                                                options={areaList.map((area) => ({
                                                    value: area.AreaCode,
                                                    label: `${area.AreaName} (${area.AreaCode})`,
                                                }))}
                                                className="basic-single form-control form-control-sm p-1 custom-select"
                                                placeholder="Search Area"
                                                styles={style}
                                                isSearchable
                                                value={selectArea}
                                                isDisabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                onChange={handleSelectArea}
                                            />
                                            <i
                                                className="fas fa-search text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "15px",
                                                    top: "63%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                        </div>

                                        {/* {console.log("selectArea", selectArea)} */}


                                        {
                                            selectArea &&
                                                selectArea.label.includes("Other") ? (
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder=""
                                                        className=" form-control input-text form-control-sm mt-1"
                                                        id="specificArea"
                                                        name="specificArea"
                                                        value={userData.specificArea}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="floatingInput" className="mt-2">
                                                        Specific Area Name
                                                    </label>
                                                </div>
                                            ) : null}

                                        <div className="search-building" style={{ position: "relative" }}>
                                            <label className="select-search-label mt-1">Building*</label>
                                            <Select
                                                options={buildingList.map((building) => ({
                                                    value: building.BuildingCode,
                                                    label: `${building.BuildingName} (${building.BuildingCode})`,
                                                }))}
                                                className="basic-single form-control form-control-sm p-1 custom-select"
                                                placeholder="Search Building"
                                                styles={style}
                                                isSearchable
                                                value={selectBuilding}
                                                isDisabled={
                                                    ContactId && checkStatusReason == "Lead Created/Closed"
                                                }
                                                onChange={(selectedOption) =>
                                                    setSelectBuilding(selectedOption)
                                                }
                                            />
                                            <i
                                                className="fas fa-search text-secondary"
                                                style={{
                                                    position: "absolute",
                                                    right: "15px",
                                                    top: "63%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            ></i>
                                        </div>

                                        {/* {console.log("selectBuilding", selectBuilding)} */}

                                        {
                                            selectBuilding &&
                                                selectBuilding.label.includes("Other") ? (
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder=""
                                                        className=" form-control input-text form-control-sm mt-1"
                                                        id="specificBuilding"
                                                        name="specificBuilding"
                                                        value={userData.specificBuilding}
                                                        onChange={handleChange}
                                                    />
                                                    <label htmlFor="floatingInput" className="mt-2">
                                                        Specific Building Name
                                                    </label>
                                                </div>
                                            ) : null}


                                        <div className="">
                                            <label className="select-search-label mt-1">Building Type*</label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="subBusiness"
                                                placeholder="Select"
                                                styles={style}
                                                value={selectBuildingType}
                                                isSearchable={false}
                                                onChange={handleSelectBuildingType}
                                                options={optionBuildingType.map((data) => ({
                                                    value: data.value,
                                                    label: data.label,
                                                }))}
                                            />
                                        </div>


                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="buildingNoPlotNo"
                                                name="buildingNoPlotNo"
                                                value={userData.buildingNoPlotNo}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Building No./Plot No.*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="block"
                                                name="block"
                                                value={userData.block}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Block*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="floor"
                                                name="floor"
                                                value={userData.floor}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Floor*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="street"
                                                name="street"
                                                value={userData.street}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Street Name*
                                            </label>
                                        </div>

                                        {/* <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="locality"
                                                name="locality"
                                                value={userData.locality}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Locality*
                                            </label>
                                        </div> */}

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="landmarkIfAny"
                                                name="landmarkIfAny"
                                                value={userData.landmarkIfAny}
                                                onChange={handleChange}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Landmark If Any*
                                            </label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm mt-1"
                                                id="pinCode"
                                                name="pinCode"
                                                value={userData.pinCode}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (userData.pinCode.length < 6 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            <label htmlFor="floatingInput" className="mt-2">
                                                Pin Code*
                                            </label>
                                        </div>
                                    </form>
                                </div>
                            )}
                            <div
                                className="Installation-toggle mt-3"
                                onClick={() => handleIconClick("form4")}
                            >
                                <span className="toggle-text">Remarks</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>

                            {activeForm === "form4" && (
                                <div
                                    className=" container shadow  mb-3 bg-body rounded mt-4"
                                    id="form4"
                                >
                                    <form className="Remark-form p-2">

                                        <div className="remark-area">
                                            <label htmlFor="floatingInput">Remarks</label>
                                            <textarea
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm textarea"
                                                id="remark"
                                                name="remark"
                                                value={userData.remark ?? remarkTemplate}
                                                onChange={handleChange}
                                                rows={16}
                                            />

                                        </div>

                                    </form>
                                </div>
                            )}
                            {ContactId &&
                                otpContactStatus !== "Contact - Valid" &&
                                otpContactStatus !== "111260000" &&
                                (otpSent ? (
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="text-center mt-5">
                                                <button
                                                    type="submit"
                                                    className="btn text-light bg-dark mx-auto rounded-pill btn-verify_otp"
                                                    onClick={() =>
                                                        handleResendOtp(
                                                            userData.contactPerson3Email,
                                                            userData.contactPerson3Mobile
                                                        )
                                                    }
                                                >
                                                    Resend Code
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-center mt-5">
                                                <button
                                                    type="submit"
                                                    className="btn text-light bg-dark mx-auto rounded-pill btn-resend_otp"
                                                    onClick={handleVerifyOtp}
                                                >
                                                    Submit Code
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-center mt-5 mb-3">
                                        <button
                                            type="submit"
                                            className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                                            onClick={() =>
                                                handleSendOtp(userData.contactPerson3Email, userData.contactPerson3Mobile)
                                            }
                                        >
                                            Send Code
                                        </button>
                                    </div>
                                ))}

                           
                            {otpContactStatus !== "Contact - Valid" &&
                                !(ContactId && checkStatusReason === 'Lead Created/Closed') && (
                                    <div className="text-center mt-5 mb-5">
                                        <button
                                            type="button"
                                            className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                                            onClick={handleSubmit}
                                        >
                                            Save
                                        </button>
                                    </div>
                                )}

                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default BusinessBdrContactFormPg;
